				<template>
	<div class="chat-box" @click="closeRefBox()" @mousemove="readedMessage()">
		<el-container>
			<el-header height="50px">
				<span class="chat-title">{{ title }}</span>
				<div class="chat-resource-tabs">
					<button
						v-for="tab in resourceTabs"
						:key="tab.type"
						type="button"
						class="chat-resource-tab"
						:class="{ active: showResourcePanel && activeResourceType === tab.type }"
						@click.stop="openResourcePanel(tab.type)"
					>{{ tab.label }}</button>
				</div>
				<span title="群聊信息" v-show="isGroup" class="btn-side el-icon-more" @click="toggleGroupSide"></span>
			</el-header>
			<el-main style="padding: 0;">
				<el-container>
					<el-container class="content-box">
						<el-main class="im-chat-main" id="chatScrollBox" @scroll="onScroll">
							<div class="im-chat-box">
								<div v-for="(msgInfo, idx) in showMessages" :key="showMinIdx + idx" :data-message-id="getMessageDomId(msgInfo)">
									<chat-message-item @call="onCall(msgInfo.type)"
										:mine="msgInfo.sendId == mine.id" :headImage="headImage(msgInfo)"
										:userId="messageUserId(msgInfo)"
										:showName="showName(msgInfo)" :originalName="originalName(msgInfo)" :msgInfo="msgInfo" :groupMembers="groupMembers"
										:chatType="chat.type"
										:selectionMode="selectionMode && !resourceSelectionMode" :selected="isSelectedMessage(msgInfo)"
										@delete="deleteMessage" @recall="recallMessage" @forward="forwardMessage" @quote="onQuoteMessage"
										@retry-send="retryTextMessage"
										@favorite="favoriteMessage" @multi-select="enterMultiSelect" @toggle-select="toggleSelectedMessage">
									</chat-message-item>
								</div>
							</div>
						</el-main>
						<div v-if="!isInBottom" class="scroll-to-bottom" @click="scrollToBottom">
							{{ newMessageSize > 0 ? newMessageSize + '条新消息' : '回到底部' }}
						</div>
						<el-footer height="220px" class="im-chat-footer">
							<div v-if="selectionMode" class="multi-select-bar">
								<div class="multi-select-count">已选择 {{ selectedMessageIds.length }} 条</div>
								<div class="multi-select-actions">
									<div class="batch-forward-wrapper">
										<el-button size="mini" type="primary" @click.stop="batchForwardMessages">批量转发</el-button>
										<div v-if="showBatchForwardMenu" class="batch-forward-menu" @click.stop>
											<div class="batch-forward-menu-item" @click="forwardBatchAs('separate')">逐条转发</div>
											<div class="batch-forward-menu-item" @click="forwardBatchAs('merged')">合并转发</div>
										</div>
									</div>
									<el-button size="mini" @click="batchFavoriteMessages">收藏</el-button>
									<el-button size="mini" type="danger" @click="batchDeleteMessages">删除</el-button>
									<el-button size="mini" @click="cancelMultiSelect">取消</el-button>
								</div>
							</div>
							<div class="chat-tool-bar">
								<div title="表情" class="icon iconfont icon-emoji" ref="emotion"
									@click.stop="showEmotionBox()">
								</div>
								<div title="截图" class="el-icon-scissors" @click.stop="onScreenshot"></div>
								<div title="发送图片">
									<file-upload :action="'/image/upload'" :maxSize="5 * 1024 * 1024"
										:fileTypes="['image/jpeg', 'image/png', 'image/jpg', 'image/webp', 'image/gif']"
										@before="onImageBefore" @success="onImageSuccess" @fail="onImageFail">
										<i class="el-icon-picture-outline"></i>
									</file-upload>
								</div>
								<div title="发送文件">
									<file-upload ref="fileUpload" :action="'/file/upload'" :maxSize="10 * 1024 * 1024"
										@before="onFileBefore" @success="onFileSuccess" @fail="onFileFail">
										<i class="el-icon-wallet"></i>
									</file-upload>
								</div>
									<div title="发送语音" class="el-icon-microphone" @click="showRecordBox()">
									</div>
								<div title="语音通话" v-show="isPrivate" class="el-icon-phone-outline"
									@click="showPrivateVideo('voice')">
								</div>
								<div title="语音通话" v-show="isGroup" class="el-icon-phone-outline"
									@click="onGroupVideo()">
								</div>
								<div title="视频通话" v-show="isPrivate" class="el-icon-video-camera"
									@click="showPrivateVideo('video')">
								</div>
								<div title="聊天记录" class="el-icon-chat-dot-round" @click="showHistoryBox()"></div>
								<!-- 名片：点击后选择好友发送名片 -->
								<div class="friend-card-btn" title="发送名片" @click="onSendFriendCard">
									<i class="el-icon-postcard"></i>
								</div>
								<div class="favorite-tool-btn" title="收藏" @click="openFavoritePicker">
									<svg class="favorite-cube-outline-icon" viewBox="0 0 24 24" aria-hidden="true">
										<path d="M12 2.5 20.5 7.2 20.5 16.8 12 21.5 3.5 16.8 3.5 7.2Z"></path>
										<path d="M3.8 7.4 12 12 20.2 7.4M12 12V21"></path>
									</svg>
								</div>
							</div>
							<div class="send-content-area" @click="onClickEditorArea">
								<ChatInput :ownerId="group.ownerId" ref="chatInputEditor" :group-members="groupMembers"
									@submit="sendMessage" @empty-change="onInputEmptyChange" :send-mode="sendMode"
									:allow-empty-submit="true" />
								<div v-if="quoteMessage" class="chat-quote-bar"
									:class="{ 'quote-bar-two-line': isTwoLineQuote(quoteMessage) }">
									<div class="quote-pill"
										:class="{
											'quote-pill-rich': isRichQuote(quoteMessage),
											'quote-pill-two-line': isTwoLineQuote(quoteMessage)
										}"
										:title="`${quoteMessage.sendNickName || showName(quoteMessage)}：${getQuoteText(quoteMessage)}`">
										<template v-if="isRichQuote(quoteMessage)">
										<template v-if="isQuoteImage(quoteMessage)">
											<span class="quote-heading">
												<span class="quote-name">{{ quoteMessage.sendNickName || showName(quoteMessage) }}：</span>
											</span>
											<img v-if="isQuoteImage(quoteMessage)" class="quote-rich-thumb" :src="getQuoteImageSrc(quoteMessage)" alt="图片" />
										</template>
										<template v-else-if="isQuoteLocation(quoteMessage)">
											<div class="quote-location-main">
												<div class="quote-flow-copy">
													<span class="quote-flow-prefix">
														<span class="quote-name">{{ quoteMessage.sendNickName || showName(quoteMessage) }}：</span>
														<span class="quote-type-label">{{ getQuoteTypeLabel(quoteMessage) }}</span>
													</span>
													<span class="quote-flow-body">　　<i class="quote-location-icon el-icon-location-outline"></i><span class="quote-location-text">{{ getQuoteLocationText(quoteMessage) }}</span></span>
												</div>
											</div>
											<img v-if="getQuoteLocationMapUrl(quoteMessage)" class="quote-location-thumb"
												:src="getQuoteLocationMapUrl(quoteMessage)" alt="位置地图" />
										</template>
										<template v-else-if="isQuoteFriendCard(quoteMessage)">
												<span class="quote-heading">
													<span class="quote-name">{{ quoteMessage.sendNickName || showName(quoteMessage) }}：</span>
													<span class="quote-type-label">{{ getQuoteTypeLabel(quoteMessage) }}</span>
												</span>
												<div class="quote-card-brief">
													<i class="quote-card-type-icon el-icon-user"></i>
													<span class="quote-card-name">{{ getQuoteFriendCardName(quoteMessage) }}</span>
												</div>
												<head-image class="quote-rich-thumb" :name="getQuoteFriendCardName(quoteMessage)"
													:url="getQuoteFriendCardAvatar(quoteMessage)" :size="42" radius="6px"
													:isShowUserInfo="false"></head-image>
											</template>
											<div v-else class="quote-rich-main">
												<div v-if="isQuoteFile(quoteMessage)" class="quote-flow-copy">
													<span class="quote-flow-prefix">
														<span class="quote-name">{{ quoteMessage.sendNickName || showName(quoteMessage) }}：</span>
														<span class="quote-type-label">{{ getQuoteTypeLabel(quoteMessage) }}</span>
													</span>
													<span class="quote-flow-body">　　{{ getRichQuoteText(quoteMessage) }}</span>
												</div>
												<div v-else class="quote-rich-line">
													<span class="quote-heading">
														<span class="quote-name">{{ quoteMessage.sendNickName || showName(quoteMessage) }}：</span>
														<span class="quote-type-label">{{ getQuoteTypeLabel(quoteMessage) }}</span>
													</span>
													<i class="quote-rich-icon el-icon-document"></i>
													<span class="quote-rich-text">{{ getRichQuoteText(quoteMessage) }}</span>
												</div>
											</div>
											<div v-if="isQuoteFile(quoteMessage)" class="quote-rich-thumb quote-file-placeholder">
												<span class="quote-file-icon" :class="getQuoteFileIconMeta(quoteMessage).className">
													<span class="file-icon-paper">
														<span class="file-icon-fold"></span>
														<span class="file-icon-mark">{{ getQuoteFileIconMeta(quoteMessage).mark }}</span>
													</span>
												</span>
											</div>
										</template>
										<template v-else>
											<div class="quote-flow-copy">
												<span class="quote-flow-prefix">
													<span class="quote-name">{{ quoteMessage.sendNickName || showName(quoteMessage) }}：</span>
													<span v-if="getQuoteTypeLabel(quoteMessage)" class="quote-type-label">{{ getQuoteTypeLabel(quoteMessage) }}</span>
												</span>
												<span v-if="getQuoteBodyText(quoteMessage)" class="quote-flow-body">　　{{ getQuoteBodyText(quoteMessage) }}</span>
											</div>
										</template>
									</div>
									<button class="quote-close" type="button" title="取消引用" @click.stop="cancelQuote">
										<i class="el-icon-close"></i>
									</button>
								</div>
								<div class="send-btn-area">
									<el-button type="primary" icon="el-icon-s-promotion"
										:disabled="!canSendMessage"
										:class="{ 'send-btn-disabled': !canSendMessage }"
										@click="notifySend()">发送</el-button>
									<el-dropdown trigger="click" :disabled="!canSendMessage" :class="{ 'send-mode-disabled': !canSendMessage }" @command="onChangeSendMode">
										<span class="send-mode-toggle" :class="{ 'is-disabled': !canSendMessage }">
											<i class="el-icon-arrow-up"></i>
										</span>
										<el-dropdown-menu slot="dropdown">
											<el-dropdown-item command="enter">
												<span>按 Enter 键发送消息</span>
												<i v-if="sendMode === 'enter'" class="el-icon-check" style="margin-left: 8px;"></i>
											</el-dropdown-item>
											<el-dropdown-item command="altEnter">
												<span>按 Alt + Enter 键发送消息</span>
												<i v-if="sendMode === 'altEnter'" class="el-icon-check" style="margin-left: 8px;"></i>
											</el-dropdown-item>
										</el-dropdown-menu>
									</el-dropdown>
								</div>
							</div>
						</el-footer>
					</el-container>
					<el-aside class="side-box" width="320px" v-if="showSide">
						<chat-group-side :group="group" :groupMembers="groupMembers" @reload="loadGroup(group.id)">
						</chat-group-side>
					</el-aside>
					<el-aside v-if="showResourcePanel" class="chat-resource-side" width="340px">
						<div class="chat-resource-panel" @click.stop="onResourcePanelClick">
							<div class="chat-resource-panel-header">
								<span>{{ activeResourceLabel }}</span>
								<button type="button" class="chat-resource-close" title="关闭" @click.stop="closeResourcePanel">
									<i class="el-icon-close"></i>
								</button>
							</div>
							<div class="chat-resource-search">
								<el-input
									size="small"
									clearable
									v-model="resourceSearchText"
									:placeholder="`搜索${activeResourceLabel}`">
									<i class="el-icon-search el-input__icon" slot="prefix"></i>
								</el-input>
							</div>
							<div v-if="!filteredResourceMessages.length" class="chat-resource-empty">暂无内容</div>
							<el-scrollbar v-else class="chat-resource-list">
								<div
									v-for="item in filteredResourceMessages"
									:key="item.key"
									class="chat-resource-row"
									:class="{ 'chat-resource-row-link': item.panelType === 'link', 'chat-resource-row-selecting': resourceSelectionMode, selected: isResourceItemSelected(item) }"
									@click="onResourceItemClick(item)"
									@contextmenu.prevent="showResourceActionMenu(item, $event)"
									@touchstart="startResourceLongPress(item, $event)"
									@touchmove="cancelResourceLongPress"
									@touchend="cancelResourceLongPress"
									@mousedown.left="startResourceLongPress(item, $event)"
									@mouseup="cancelResourceLongPress"
									@mouseleave="cancelResourceLongPress"
								>
									<button
										v-if="resourceSelectionMode"
										type="button"
										class="chat-resource-select-dot"
										:class="{ selected: isResourceItemSelected(item) }"
										@click.stop="toggleResourceItemSelection(item)"
									>
										<i v-if="isResourceItemSelected(item)" class="el-icon-check"></i>
									</button>
									<img v-if="item.thumbUrl" class="chat-resource-thumb" :src="item.thumbUrl" alt="" />
									<div v-else class="chat-resource-icon" :class="`chat-resource-icon-${item.panelType}`">
										<i :class="item.icon"></i>
									</div>
									<div class="chat-resource-info">
										<div class="chat-resource-title">{{ item.title }}</div>
										<div class="chat-resource-summary">{{ item.summary }}</div>
										<div class="chat-resource-meta">
											<span>{{ item.sender }}</span>
											<span>{{ formatResourceTime(item.sendTime) }}</span>
										</div>
									</div>
								</div>
							</el-scrollbar>
							<div
								v-if="resourceActionMenu.visible"
								class="chat-resource-action-menu"
								:style="{ left: resourceActionMenu.x + 'px', top: resourceActionMenu.y + 'px' }"
								@click.stop
							>
								<button
									v-for="actionItem in getResourceActionItems(resourceActionMenu.item)"
									:key="actionItem.action"
									type="button"
									class="chat-resource-action-item"
									@click.stop="handleResourceAction(actionItem.action)"
								>{{ actionItem.label }}</button>
							</div>
						</div>
					</el-aside>
				</el-container>
			</el-main>
			<emotion ref="emoBox" @emotion="onEmotion"></Emotion>
			<chat-record :visible="showRecord" @close="closeRecordBox" @send="onSendRecord"></chat-record>
			<group-member-selector ref="rtcSel" :group="group" @complete="onInviteOk"></group-member-selector>
			<rtc-group-join ref="rtcJoin" :groupId="group.id"></rtc-group-join>
			<chat-history :visible="showHistory" :chat="chat" :friend="friend" :group="group"
				:groupMembers="groupMembers" @close="closeHistoryBox"></chat-history>
			<favorite-panel :visible="showFavoritePanel" :mode="favoritePanelMode"
				@close="closeFavoritePanel" @send="sendFavoriteMessage"></favorite-panel>
			<forward-select :visible="showForwardSelect" :forwardMsg="forwardMsg" :forwardBatch="forwardBatch"
				@close="closeForwardSelect" @friendPicked="onFriendPicked" @batchForwarded="onBatchForwarded"></forward-select>
		</el-container>
		<rtc-call-starting :visible="callStartVisible" :state="callStartState" mode="video" group
			:remaining-seconds="callStartRemainingSeconds" :detail="callStartDetail"
			@cancel="cancelGroupCallStart"></rtc-call-starting>
	</div>
</template>

<script>
import ChatGroupSide from "./ChatGroupSide.vue";
import ChatMessageItem from "./ChatMessageItem.vue";
import FileUpload from "../common/FileUpload.vue";
import Emotion from "../common/Emotion.vue";
import ChatRecord from "./ChatRecord.vue";
import ChatHistory from "./ChatHistory.vue";
import ChatAtBox from "./ChatAtBox.vue"
import GroupMemberSelector from "../group/GroupMemberSelector.vue"
import RtcGroupJoin from "../rtc/RtcGroupJoin.vue"
import RtcCallStarting from "../rtc/RtcCallStarting.vue"
import ChatInput from "./ChatInput";
import ForwardSelect from "../friend/ForwardSelect.vue";
import FavoritePanel from "../favorite/FavoritePanel.vue";
import HeadImage from "../common/HeadImage.vue";
import { getFileIconMetaFromContent } from "../../utils/fileIcon";
import {
	createCallStartRetry,
	generateClientCallId,
	resolveCallStartRetryTimeoutMs
} from "../../api/callStartRetry";

const DELETE_MESSAGE_CONFIRM_TITLE = '确定删除消息吗？';
const DELETE_MESSAGE_CONFIRM_CONTENT = '此消息将从你的所有设备上删除，不可恢复，但仍对会话内其他人可见';
const DEFAULT_TEXT_SEND_RETRY_WINDOW = 3 * 60 * 1000;
const TEXT_SEND_MAX_RETRY_DELAY = 30 * 1000;
const TEXT_SEND_OFFLINE_RETRY_DELAY = 5 * 1000;

export default {
	name: "chatPrivate",
	components: {
		ChatInput,
		ChatMessageItem,
		FileUpload,
		ChatGroupSide,
		Emotion,
		ChatRecord,
		ChatHistory,
		ChatAtBox,
		GroupMemberSelector,
		RtcGroupJoin,
		RtcCallStarting,
		ForwardSelect,
		FavoritePanel,
		HeadImage
	},
	props: {
		chat: {
			type: Object
		}
	},
	data() {
		return {
			userInfo: {},
			group: {},
			groupMembers: [],
			sendImageUrl: "",
			sendImageFile: "",
			placeholder: "",
				isReceipt: false,
			showRecord: false, // 是否显示语音录制弹窗
			showSide: false, // 是否显示群聊信息栏
			showHistory: false, // 是否显示历史聊天记录
			lockMessage: false, // 是否锁定发送，
			showMinIdx: 0, // 下标低于showMinIdx的消息不显示，否则页面会很卡置
			reqQueue: [], // 等待发送的请求队列
			isSending: false, // 是否正在发消息
			isInBottom: false, // 滚动条是否在底部
			newMessageSize: 0, // 滚动条不在底部时新的消息数量
			pendingTextSends: Object.create(null), // 普通文字消息的本地待发送任务
			showForwardSelect: false, // 是否显示转发选择弹窗
			forwardMsg: {}, // 待转发的消息
			forwardBatch: null,
			selectionMode: false,
			selectedMessageIds: [],
			showBatchForwardMenu: false,
			showFavoritePanel: false,
			favoritePanelMode: 'picker',
			quoteMessage: null,
			showResourcePanel: false,
			resourceSelectionMode: false,
			activeResourceType: 'history',
			resourceSearchText: '',
			resourceActionMenu: {
				visible: false,
				item: null,
				x: 0,
				y: 0
			},
			resourceSuppressPanelClick: false,
			resourceLongPressTimer: null,
			isInputEmpty: true,
			callStartController: null,
			callStartCloseTimer: null,
			callStartVisible: false,
			callStartState: 'retrying',
			callStartRemainingSeconds: 30,
			callStartDetail: '',
			groupCallStartId: '',
			sendMode: localStorage.getItem('im_send_mode') || 'enter'
		}
	},
	methods: {
		onClickEditorArea(e) {
			// 避免点击发送按钮、下拉等控件时重复触发
			const tag = e.target.tagName && e.target.tagName.toLowerCase();
			if (tag === 'button' || tag === 'i' || tag === 'svg' || tag === 'path') {
				return;
			}
			this.$refs.chatInputEditor && this.$refs.chatInputEditor.focus();
		},
		onSendFriendCard() {
			if (!this.chat || !this.chat.targetId) return;
			// 置空 forwardMsg，表示当前是“选择好友发送名片”模式，而不是转发消息
			this.forwardMsg = null;
			this.showForwardSelect = true;
		},
			onFriendPicked(friend) {
			// ForwardSelect 选择好友后回调
			if (!friend || !friend.id) return;
			const card = {
				id: friend.id,
				nickName: friend.nickName,
				headImage: friend.headImageThumb || friend.headImage
			};
				let msgInfo = {
					content: JSON.stringify(card),
					type: this.$enums.MESSAGE_TYPE.FRIEND_CARD,
					receipt: this.buildReceiptEnabled()
				};
			// 填充对方 id 并发送
			this.fillTargetId(msgInfo, this.chat.targetId);
			this.sendMessageRequest(msgInfo).then((m) => {
				m.selfSend = true;
				this.syncReceiptFields(m, msgInfo);
				this.ensureLocalGroupReceiptStats(m);
				this.chatStore.insertMessage(m, this.chat);
				this.moveChatToTop();
				this.scrollToBottom();
				this.isReceipt = false;
			}).finally(() => {
				this.showForwardSelect = false;
			});
		},
		onQuoteMessage(msgInfo) {
			this.quoteMessage = msgInfo;
			this.$nextTick(() => {
				this.$refs.chatInputEditor && this.$refs.chatInputEditor.focus();
			});
		},
		moveChatToTop() {
			let chatIdx = this.chatStore.findChatIdx(this.chat);
			this.chatStore.moveTop(chatIdx);
		},
		closeRefBox() {
			this.$refs.emoBox.close();
			// this.$refs.atBox.close();
		},
		onCall(type) {
			if (type == this.$enums.MESSAGE_TYPE.ACT_RT_VOICE) {
				this.showPrivateVideo('voice');
			} else if (type == this.$enums.MESSAGE_TYPE.ACT_RT_VIDEO) {
				this.showPrivateVideo('video');
			}
		},
			onSwitchReceipt() {
				this.isReceipt = !this.isReceipt;
				this.refreshPlaceHolder();
			},
			buildReceiptEnabled() {
				return this.chat && this.chat.type === "GROUP" ? true : this.isReceipt;
			},
			isGroupReceiptMember(member, sendId = this.mine.id, sendTime = Date.now()) {
				if (!member || member.userId == sendId) {
					return false;
				}
				if (member.createdTime && sendTime && member.createdTime > sendTime) {
					return false;
				}
				if (member.quit && member.quitTime && sendTime && member.quitTime < sendTime) {
					return false;
				}
				return !member.quit || !member.quitTime || !sendTime || member.quitTime >= sendTime;
			},
			getGroupReceiptTotal(sendId = this.mine.id, sendTime = Date.now()) {
				return (this.groupMembers || []).filter(member => this.isGroupReceiptMember(member, sendId, sendTime)).length;
			},
			syncReceiptFields(target, source) {
				if (!target || !source) {
					return;
				}
				['receipt', 'receiptOk', 'receiptTotal', 'readedCount', 'unreadCount'].forEach(key => {
					if (source[key] !== undefined && source[key] !== null) {
						target[key] = source[key];
					}
				});
			},
			toReceiptStatNumber(value) {
				if (value === undefined || value === null || value === '') {
					return null;
				}
				const num = Number(value);
				return Number.isFinite(num) ? num : null;
			},
			ensureLocalGroupReceiptStats(msgInfo) {
				if (!msgInfo || this.chat.type !== "GROUP" || !this.$msgType.isNormal(msgInfo.type)) {
					return;
				}
				if ((msgInfo.sendId || this.mine.id) != this.mine.id && !msgInfo.selfSend) {
					return;
				}
				// 确保消息对象上有 groupId，否则 ChatMessageItem 的 isGroupMessage 会判断为 false，
				// 导致群聊已读/未读回执不显示
				if (!msgInfo.groupId && this.chat.targetId) {
					this.$set(msgInfo, 'groupId', this.chat.targetId);
				}
				const readedCount = this.toReceiptStatNumber(msgInfo.readedCount) || 0;
				if (!(this.groupMembers || []).length) {
					if (this.toReceiptStatNumber(msgInfo.receiptTotal) !== null &&
						this.toReceiptStatNumber(msgInfo.unreadCount) !== null) {
						return;
					}
					this.$set(msgInfo, 'readedCount', readedCount);
					return;
				}
				const sendId = msgInfo.sendId || this.mine.id;
				const sendTime = msgInfo.sendTime || new Date().getTime();
				const receiptTotal = this.getGroupReceiptTotal(sendId, sendTime);
				if (msgInfo.receipt === undefined || msgInfo.receipt === null) {
					this.$set(msgInfo, 'receipt', true);
				}
				this.$set(msgInfo, 'receiptTotal', receiptTotal);
				this.$set(msgInfo, 'readedCount', readedCount);
				this.$set(msgInfo, 'unreadCount', Math.max(receiptTotal - readedCount, 0));
				this.$set(msgInfo, 'receiptOk', msgInfo.unreadCount === 0);
			},
			refreshGroupReceiptStats(messages = this.chat.messages) {
				if (this.chat.type !== "GROUP" || !Array.isArray(messages) || !this.groupMembers.length) {
					return;
				}
				messages.forEach(msgInfo => this.ensureLocalGroupReceiptStats(msgInfo));
			},
			onImageSuccess(data, file) {
				let msgInfo = JSON.parse(JSON.stringify(file.msgInfo));
				msgInfo.content = JSON.stringify(data);
				msgInfo.receipt = this.buildReceiptEnabled();
				// 引用：若存在则附加并在后续回包缺失时补齐
				let localQuote = null;
			if (this.quoteMessage) {
				localQuote = {
					id: this.quoteMessage.id,
					type: this.quoteMessage.type,
					content: this.quoteMessage.content,
					sendId: this.quoteMessage.sendId,
					sendNickName: this.quoteMessage.sendNickName || this.showName(this.quoteMessage)
				};
				msgInfo.quoteMessage = localQuote;
				this.quoteMessage = null;
			}
				this.sendMessageRequest(msgInfo).then((m) => {
					msgInfo.loadStatus = 'ok';
					msgInfo.id = m.id;
					this.syncReceiptFields(msgInfo, m);
					this.ensureLocalGroupReceiptStats(msgInfo);
					this.isReceipt = false;
					// 若后端未回传引用信息，则用本地缓存补齐
					if (localQuote && !msgInfo.quoteMessage) {
						msgInfo.quoteMessage = localQuote;
				}
				this.chatStore.insertMessage(msgInfo, file.chat);
			})
		},
		onImageFail(e, file) {
			let msgInfo = JSON.parse(JSON.stringify(file.msgInfo));
			msgInfo.loadStatus = 'fail';
			this.chatStore.insertMessage(msgInfo, file.chat);
		},
		onImageBefore(file) {
			// 被封禁提示
			if (this.isBanned) {
				this.showBannedTip();
				return;
			}
			let url = URL.createObjectURL(file);
			let data = {
				originUrl: url,
				thumbUrl: url
			}
			let msgInfo = {
				id: 0,
				tmpId: this.generateId(),
				fileId: file.uid,
				sendId: this.mine.id,
				content: JSON.stringify(data),
				sendTime: new Date().getTime(),
				selfSend: true,
				type: 1,
				readedCount: 0,
				loadStatus: "loading",
				status: this.$enums.MESSAGE_STATUS.UNSEND
			}
			// 填充对方id
			this.fillTargetId(msgInfo, this.chat.targetId);
			// 插入消息
			this.chatStore.insertMessage(msgInfo, this.chat);
			// 会话置顶
			this.moveChatToTop();
			// 滚动到底部
			this.scrollToBottom();
			// 借助file对象保存
			file.msgInfo = msgInfo;
			file.chat = this.chat;
		},
		onFileSuccess(url, file) {
			let data = {
				name: file.name,
				size: file.size,
				url: url
			}
				let msgInfo = JSON.parse(JSON.stringify(file.msgInfo));
				msgInfo.content = JSON.stringify(data);
				msgInfo.receipt = this.buildReceiptEnabled()
			// 引用：若存在则附加并在后续回包缺失时补齐
			let localQuote = null;
			if (this.quoteMessage) {
				localQuote = {
					id: this.quoteMessage.id,
					type: this.quoteMessage.type,
					content: this.quoteMessage.content,
					sendId: this.quoteMessage.sendId,
					sendNickName: this.quoteMessage.sendNickName || this.showName(this.quoteMessage)
				};
				msgInfo.quoteMessage = localQuote;
				this.quoteMessage = null;
			}
				this.sendMessageRequest(msgInfo).then((m) => {
					msgInfo.loadStatus = 'ok';
					msgInfo.id = m.id;
					this.syncReceiptFields(msgInfo, m);
					this.ensureLocalGroupReceiptStats(msgInfo);
					this.isReceipt = false;
					this.refreshPlaceHolder();
				// 若后端未回传引用信息，则用本地缓存补齐
				if (localQuote && !msgInfo.quoteMessage) {
					msgInfo.quoteMessage = localQuote;
				}
				this.chatStore.insertMessage(msgInfo, file.chat);
			})
		},
		onFileFail(e, file) {
			let msgInfo = JSON.parse(JSON.stringify(file.msgInfo));
			msgInfo.loadStatus = 'fail';
			this.chatStore.insertMessage(msgInfo, file.chat);
		},
		onFileBefore(file) {
			// 被封禁提示
			if (this.isBanned) {
				this.showBannedTip();
				return;
			}
			let url = URL.createObjectURL(file);
			let data = {
				name: file.name,
				size: file.size,
				url: url
			}
			let msgInfo = {
				id: 0,
				tmpId: this.generateId(),
				sendId: this.mine.id,
				content: JSON.stringify(data),
				sendTime: new Date().getTime(),
				selfSend: true,
				type: 2,
				loadStatus: "loading",
				readedCount: 0,
				status: this.$enums.MESSAGE_STATUS.UNSEND
			}
			// 填充对方id
			this.fillTargetId(msgInfo, this.chat.targetId);
			// 插入消息
			this.chatStore.insertMessage(msgInfo, this.chat);
			// 会话置顶
			this.moveChatToTop();
			// 滚动到底部
			this.scrollToBottom();
			// 借助file对象透传
			file.msgInfo = msgInfo;
			file.chat = this.chat;
		},
		onCloseSide() {
			this.showSide = false;
		},
		onScrollToTop() {
			// 多展示10条信息
			this.showMinIdx = this.showMinIdx > 10 ? this.showMinIdx - 10 : 0;
		},
		onScroll(e) {
			let scrollElement = e.target
			let scrollTop = scrollElement.scrollTop
			if (scrollTop < 30) { // 在顶部,不滚动的情况
				// 多展示20条信息
				this.showMinIdx = this.showMinIdx > 20 ? this.showMinIdx - 20 : 0;
				this.isInBottom = false;
			}
			// 滚到底部
			if (scrollTop + scrollElement.clientHeight >= scrollElement.scrollHeight - 30) {
				this.isInBottom = true;
				this.newMessageSize = 0;
			}
		},
		showEmotionBox() {
			let width = this.$refs.emotion.offsetWidth;
			let left = this.$elm.fixLeft(this.$refs.emotion);
			let top = this.$elm.fixTop(this.$refs.emotion);
			this.$refs.emoBox.open({
				x: left + width / 2,
				y: top
			})
		},
		onEmotion(emoText) {
			this.$refs.chatInputEditor.insertEmoji(emoText);
		},
		showRecordBox() {
			this.showRecord = true;
		},
		closeRecordBox() {
			this.showRecord = false;
		},
		showPrivateVideo(mode) {
			// 检查是否被封禁
			if (this.isBanned) {
				this.showBannedTip();
				return;
			}

			let rtcInfo = {
				mode: mode,
				isHost: true,
				friend: this.friend,
			}
			// 通过home.vue打开单人视频窗口
			this.$eventBus.$emit("openPrivateVideo", rtcInfo);
		},
		onGroupVideo() {
			// 检查是否被封禁
			if (this.isBanned) {
				this.showBannedTip();
				return;
			}
			// 邀请成员发起通话（发起者默认勾选）
			let ids = [this.mine.id];
			let maxChannel = Math.min(this.configStore.webrtc.maxChannel || 8, 8);
			this.$refs.rtcSel.open(maxChannel, ids, ids, []);
		},
		onInviteOk(members) {
			if (members.length < 2) {
				return;
			}
			let userInfos = [];
			// 添加所有被邀请的成员（包括发起者自己）
			members.forEach(m => {
				userInfos.push({
					id: m.userId,
					nickName: m.showNickName,
					headImage: m.headImage,
					isCamera: false,
					isMicroPhone: true
				})
			})
			const clientCallId = generateClientCallId(this.mine.id);
			this.groupCallStartId = clientCallId;
			const timeoutMs = resolveCallStartRetryTimeoutMs(this.configStore);
			this.callStartRemainingSeconds = Math.ceil(timeoutMs / 1000);
			this.callStartController = createCallStartRetry(({ requestTimeoutMs }) => this.$http({
				url: '/webrtc/group/invite',
				method: 'POST',
				timeout: requestTimeoutMs,
				silent: true,
				data: {
					groupId: this.group.id,
					userInfos: userInfos,
					clientCallId
				}
			}), {
				timeoutMs,
				onRetry: ({ remainingSeconds }) => {
					this.callStartVisible = true;
					this.callStartState = 'retrying';
					this.callStartRemainingSeconds = remainingSeconds;
					this.callStartDetail = '网络连接不稳定，正在重新提交群聊邀请';
				}
			});
			this.callStartController.promise.then(() => {
				this.callStartController = null;
				this.callStartVisible = false;
				console.log('群聊邀请发送成功');
				// 发起者的userInfos已经包含了所有成员（包括自己）
				let hostUserInfos = [...userInfos];
				let rtcInfo = {
					isHost: true,
					groupId: this.group.id,
					inviterId: this.mine.id,
					userInfos: hostUserInfos
				}
				// 通过home.vue打开多人视频窗口
				this.$eventBus.$emit("openGroupVideo", rtcInfo);
			}).catch(error => {
				this.callStartController = null;
				console.error('群聊邀请发送失败:', error);
				this.finishGroupCallStartFailure();
			});
		},
		cancelGroupCallStart() {
			if (this.callStartController) {
				this.callStartController.cancel();
			} else {
				this.finishGroupCallStartFailure();
			}
		},
		finishGroupCallStartFailure() {
			this.callStartVisible = true;
			this.callStartState = 'cancelled';
			this.callStartRemainingSeconds = 0;
			this.callStartDetail = '未能连接到服务，本次群聊通话已取消';
			this.$http({
				url: `/webrtc/group/start/cancel?groupId=${this.group.id}&clientCallId=${encodeURIComponent(this.groupCallStartId || '')}`,
				method: 'POST',
				timeout: 3000,
				silent: true
			}).catch(() => {});
			if (this.callStartCloseTimer) {
				clearTimeout(this.callStartCloseTimer);
			}
			this.callStartCloseTimer = setTimeout(() => {
				this.callStartCloseTimer = null;
				this.callStartVisible = false;
			}, 1200);
		},
		showHistoryBox() {
			this.showHistory = true;
		},
		closeHistoryBox() {
			this.showHistory = false;
		},
		toggleGroupSide() {
			this.showSide = !this.showSide;
			if (this.showSide) {
				this.closeResourcePanel();
			}
		},
		openResourcePanel(type) {
			this.activeResourceType = type;
			this.resourceSearchText = '';
			this.showResourcePanel = true;
			this.showSide = false;
			this.closeResourceActionMenu();
		},
		closeResourcePanel() {
			if (this.resourceSelectionMode) {
				this.cancelMultiSelect();
			}
			this.showResourcePanel = false;
			this.resourceSearchText = '';
			this.closeResourceActionMenu();
		},
		startResourceLongPress(item, event) {
			if (!item) {
				return;
			}
			this.cancelResourceLongPress();
			this.resourceLongPressTimer = setTimeout(() => {
				this.showResourceActionMenu(item, event);
			}, 550);
		},
		cancelResourceLongPress() {
			if (this.resourceLongPressTimer) {
				clearTimeout(this.resourceLongPressTimer);
				this.resourceLongPressTimer = null;
			}
		},
		showResourceActionMenu(item, event) {
			if (!item) {
				return;
			}
			this.cancelResourceLongPress();
			if (event && event.preventDefault) {
				event.preventDefault();
			}
			const point = this.getResourceMenuPoint(event);
			this.resourceActionMenu = {
				visible: true,
				item,
				x: point.x,
				y: point.y
			};
			this.resourceSuppressPanelClick = !!(event && /^(touchstart|mousedown)$/.test(event.type));
		},
		getResourceActionItems(item) {
			if (!item) {
				return [];
			}
			if (item.panelType === 'history' || item.panelType === 'location') {
				return [
					{ action: 'copy', label: '复制' },
					{ action: 'multiSelect', label: '多选' },
					{ action: 'forward', label: '转发' }
				];
			}
			return [
				{ action: 'open', label: '打开' },
				{ action: 'download', label: '下载' },
				{ action: 'multiSelect', label: '多选' },
				{ action: 'forward', label: '转发' }
			];
		},
		getResourceMenuPoint(event) {
			const sourceEvent = event && event.touches && event.touches[0] ? event.touches[0] : event;
			const clientX = sourceEvent && sourceEvent.clientX ? sourceEvent.clientX : window.innerWidth - 150;
			const clientY = sourceEvent && sourceEvent.clientY ? sourceEvent.clientY : 120;
			return {
				x: Math.min(Math.max(8, clientX), window.innerWidth - 112),
				y: Math.min(Math.max(8, clientY), window.innerHeight - 132)
			};
		},
		closeResourceActionMenu() {
			this.cancelResourceLongPress();
			this.resourceSuppressPanelClick = false;
			if (!this.resourceActionMenu.visible && !this.resourceActionMenu.item) {
				return;
			}
			this.resourceActionMenu = {
				visible: false,
				item: null,
				x: 0,
				y: 0
			};
		},
		onResourcePanelClick() {
			if (this.resourceSuppressPanelClick) {
				this.resourceSuppressPanelClick = false;
				return;
			}
			this.closeResourceActionMenu();
		},
		handleResourceAction(action) {
			const item = this.resourceActionMenu.item;
			this.closeResourceActionMenu();
			if (!item) {
				return;
			}
			if (action === 'open') {
				this.openResourceItem(item);
				return;
			}
			if (action === 'download') {
				this.downloadResourceItem(item);
				return;
			}
			if (action === 'copy') {
				this.copyResourceItem(item);
				return;
			}
			if (action === 'multiSelect') {
				this.multiSelectResourceItem(item);
				return;
			}
			if (action === 'forward') {
				this.forwardResourceItem(item);
			}
		},
		openResourceItem(item) {
			if (!item) {
				return;
			}
			const url = item.panelType === 'link' ? item.url : this.getResourceItemUrl(item);
			if (!url) {
				this.$message.error('文件地址无效');
				return;
			}
			window.open(url, '_blank', 'noopener,noreferrer');
		},
		downloadResourceItem(item) {
			if (!item) {
				return;
			}
			const url = item.panelType === 'link' ? item.url : this.getResourceItemUrl(item);
			if (!url) {
				this.$message.error('下载地址无效');
				return;
			}
			const data = this.parseResourceContent(item.msgInfo);
			const name = item.panelType === 'link'
				? this.sanitizeResourceDownloadName(`${item.title || 'link'}.html`)
				: this.sanitizeResourceDownloadName(data.name || data.fileName || item.title || '');
			this.triggerResourceDownload(url, name);
		},
		forwardResourceItem(item) {
			if (!item || !item.msgInfo) {
				return;
			}
			this.forwardMessage(item.msgInfo);
		},
		copyResourceItem(item) {
			const text = this.getResourceCopyText(item);
			if (!text) {
				this.$message.warning('暂无可复制内容');
				return;
			}
			this.copyResourceText(text);
		},
		getResourceCopyText(item) {
			if (!item || !item.msgInfo) {
				return '';
			}
			return this.getPlainMessageText(item.msgInfo) || this.getQuoteText(item.msgInfo) || item.title || item.summary || '';
		},
		copyResourceText(text) {
			if (navigator.clipboard && window.isSecureContext) {
				navigator.clipboard.writeText(text).then(() => {
					this.$message.success('复制成功');
				}).catch(() => {
					this.fallbackCopyResourceText(text);
				});
				return;
			}
			this.fallbackCopyResourceText(text);
		},
		fallbackCopyResourceText(text) {
			const input = document.createElement('textarea');
			input.value = text;
			input.setAttribute('readonly', 'readonly');
			input.style.position = 'fixed';
			input.style.left = '-9999px';
			document.body.appendChild(input);
			input.select();
			try {
				document.execCommand('copy');
				this.$message.success('复制成功');
			} catch (e) {
				this.$message.error('复制失败');
			}
			document.body.removeChild(input);
		},
		multiSelectResourceItem(item) {
			if (!item || !item.msgInfo) {
				return;
			}
			this.resourceSelectionMode = true;
			this.selectionMode = true;
			this.selectedMessageIds = [];
			this.toggleSelectedMessage(item.msgInfo);
		},
		getResourceItemUrl(item) {
			if (!item) {
				return '';
			}
			if (item.url) {
				return item.url;
			}
			return this.getResourceUrl(item.msgInfo, this.parseResourceContent(item.msgInfo));
		},
		sanitizeResourceDownloadName(name) {
			return String(name || 'download')
				.replace(/[\\/:*?"<>|]/g, '_')
				.trim() || 'download';
		},
		triggerResourceDownload(url, name) {
			const link = document.createElement('a');
			link.href = url;
			link.download = name || '';
			link.target = '_blank';
			link.rel = 'noopener noreferrer';
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);
		},
		getMessageDomId(msgInfo) {
			if (!msgInfo) {
				return '';
			}
			return msgInfo.id || msgInfo.tmpId || '';
		},
		getResourceMessages() {
			const messages = this.chat && Array.isArray(this.chat.messages) ? this.chat.messages : [];
			if (this.activeResourceType === 'media') {
				return messages
					.filter(msg => msg && (msg.type == this.$enums.MESSAGE_TYPE.FILE || msg.type == this.$enums.MESSAGE_TYPE.IMAGE || msg.type == this.$enums.MESSAGE_TYPE.VIDEO))
					.map(msg => msg.type == this.$enums.MESSAGE_TYPE.FILE
						? this.buildResourceMessageItem(msg, { panelType: 'file', icon: 'el-icon-document' })
						: this.buildResourceMessageItem(msg, { panelType: 'media', icon: msg.type == this.$enums.MESSAGE_TYPE.IMAGE ? 'el-icon-picture-outline' : 'el-icon-video-camera' }));
			}
			if (this.activeResourceType === 'link') {
				const linkItems = [];
				messages
					.filter(msg => msg && this.extractMessageLinks(msg).length > 0)
					.forEach(msg => {
						this.extractMessageLinks(msg).forEach((url, index) => {
							linkItems.push(this.buildResourceMessageItem(msg, {
								panelType: 'link',
								icon: 'el-icon-link',
								url: this.normalizeResourceLink(url),
								title: url,
								keySuffix: `link-${index}`
							}));
						});
					});
				return linkItems;
			}
			if (this.activeResourceType === 'location') {
				return messages
					.filter(msg => msg && msg.type == this.$enums.MESSAGE_TYPE.LOCATION)
					.map(msg => this.buildResourceMessageItem(msg, { panelType: 'location', icon: 'el-icon-location-outline' }));
			}
			return messages
				.filter(msg => msg && this.$msgType.isNormal(msg.type))
				.map(msg => this.buildResourceMessageItem(msg, { panelType: 'history', icon: 'el-icon-chat-line-round' }));
		},
		buildResourceMessageItem(msgInfo, options = {}) {
			const panelType = options.panelType || this.activeResourceType;
			const data = this.parseResourceContent(msgInfo);
			const sender = this.showName(msgInfo) || (msgInfo.selfSend ? this.mine.nickName : this.chat.showName) || '';
			const title = options.title || this.getResourceTitle(msgInfo, panelType, data);
			const summary = this.getResourceSummary(msgInfo, panelType, data);
			const domId = this.getMessageDomId(msgInfo);
			return {
				key: `${panelType}-${domId || msgInfo.sendTime || Math.random()}-${options.keySuffix || ''}`,
				panelType,
				msgInfo,
				domId,
				title,
				summary,
				sender,
				sendTime: msgInfo.sendTime,
				url: options.url || this.getResourceUrl(msgInfo, data),
				thumbUrl: this.getResourceThumbUrl(msgInfo, data),
				icon: options.icon || 'el-icon-chat-line-round',
				searchText: [title, summary, sender, options.url || ''].join(' ')
			};
		},
		parseResourceContent(msgInfo) {
			if (!msgInfo || !msgInfo.content) {
				return {};
			}
			if (typeof msgInfo.content === 'object') {
				return msgInfo.content;
			}
			try {
				return JSON.parse(msgInfo.content);
			} catch (e) {
				return {};
			}
		},
		getResourceTitle(msgInfo, panelType, data) {
			if (panelType === 'file') {
				return data.name || '文件';
			}
			if (panelType === 'media') {
				return msgInfo.type == this.$enums.MESSAGE_TYPE.IMAGE ? '图片' : '视频';
			}
			if (panelType === 'link') {
				const links = this.extractMessageLinks(msgInfo);
				return links[0] || '链接';
			}
			if (panelType === 'location') {
				return data.name || '位置';
			}
			return this.getQuoteText(msgInfo);
		},
		getResourceSummary(msgInfo, panelType, data) {
			if (panelType === 'file') {
				return data.size ? this.fileSizeText(data.size) : '文件消息';
			}
			if (panelType === 'media') {
				return msgInfo.type == this.$enums.MESSAGE_TYPE.IMAGE ? '图片消息' : '视频消息';
			}
			if (panelType === 'link') {
				return this.getPlainMessageText(msgInfo);
			}
			if (panelType === 'location') {
				return data.address || '位置消息';
			}
			return this.getPlainMessageText(msgInfo) || this.getQuoteText(msgInfo);
		},
		getResourceUrl(msgInfo, data) {
			if (!msgInfo) {
				return '';
			}
			if (msgInfo.type == this.$enums.MESSAGE_TYPE.FILE || msgInfo.type == this.$enums.MESSAGE_TYPE.IMAGE || msgInfo.type == this.$enums.MESSAGE_TYPE.VIDEO) {
				return data.url || data.originUrl || data.thumbUrl || '';
			}
			return '';
		},
		getResourceThumbUrl(msgInfo, data) {
			if (!msgInfo || msgInfo.type != this.$enums.MESSAGE_TYPE.IMAGE) {
				return '';
			}
			return data.thumbUrl || data.originUrl || data.url || '';
		},
		getPlainMessageText(msgInfo) {
			if (!msgInfo || msgInfo.type != this.$enums.MESSAGE_TYPE.TEXT) {
				return '';
			}
			return String(msgInfo.content || '')
				.replace(/<br\s*\/?>/gi, ' ')
				.replace(/<[^>]+>/g, '')
				.replace(/&nbsp;/g, ' ')
				.replace(/#[^;]+;/g, '')
				.replace(/【回执消息】/g, '')
				.replace(/\s+/g, ' ')
				.trim();
		},
		extractMessageLinks(msgInfo) {
			const text = this.getPlainMessageText(msgInfo);
			if (!text) {
				return [];
			}
			const matches = text.match(/(\bhttps?:\/\/[-A-Z0-9+&@#/%?=~_|!:,.;]*[-A-Z0-9+&@#/%=~_|]|\bwww\.[-A-Z0-9+&@#/%?=~_|!:,.;]*[-A-Z0-9+&@#/%=~_|])/ig);
			return matches || [];
		},
		normalizeResourceLink(url) {
			if (!url) {
				return '';
			}
			if (/^[a-z][a-z0-9+.-]*:\/\//i.test(url)) {
				return url;
			}
			return (process.env.VUE_APP_DEFAULT_URL_PROTOCOL || 'http://') + url;
		},
		matchesResourceSearch(item) {
			const keyword = String(this.resourceSearchText || '').trim().toLowerCase();
			if (!keyword) {
				return true;
			}
			return String(item && item.searchText || '').toLowerCase().includes(keyword);
		},
		formatResourceTime(time) {
			return time ? this.$date.toTimeText(time) : '';
		},
		fileSizeText(size) {
			const value = Number(size);
			if (!Number.isFinite(value) || value <= 0) {
				return '';
			}
			if (value < 1024) {
				return `${value}B`;
			}
			if (value < 1024 * 1024) {
				return `${(value / 1024).toFixed(1)}KB`;
			}
			return `${(value / 1024 / 1024).toFixed(1)}MB`;
		},
		onResourceItemClick(item) {
			if (!item) {
				return;
			}
			if (this.resourceActionMenu.visible) {
				return;
			}
			if (this.resourceSelectionMode) {
				this.toggleResourceItemSelection(item);
				return;
			}
			if (item.panelType === 'link' && item.url) {
				window.open(item.url, '_blank', 'noopener,noreferrer');
				return;
			}
			this.scrollToResourceMessage(item);
		},
		isResourceItemSelected(item) {
			return !!item && this.isSelectedMessage(item.msgInfo);
		},
		toggleResourceItemSelection(item) {
			if (!item || !item.msgInfo) {
				return;
			}
			this.toggleSelectedMessage(item.msgInfo);
		},
		scrollToResourceMessage(item) {
			if (!item || !item.msgInfo || !this.chat || !Array.isArray(this.chat.messages)) {
				return;
			}
			const index = this.chat.messages.findIndex(msg => msg === item.msgInfo || (msg.id && item.msgInfo.id && msg.id == item.msgInfo.id));
			if (index >= 0 && index < this.showMinIdx) {
				this.showMinIdx = Math.max(0, index - 5);
			}
			this.$nextTick(() => {
				if (!item.domId) {
					return;
				}
				const target = this.$el.querySelector(`[data-message-id="${item.domId}"]`);
				if (target && target.scrollIntoView) {
					target.scrollIntoView({ block: 'center' });
				}
			});
		},
		onSendRecord(data) {
			// 检查是否被封禁
			if (this.isBanned) {
				this.showBannedTip();
				return;
			}
				let msgInfo = {
					content: JSON.stringify(data),
					type: 3,
					receipt: this.buildReceiptEnabled()
				}
			// 引用：若存在则附加并在后续回包缺失时补齐
			let localQuote = null;
			if (this.quoteMessage) {
				localQuote = {
					id: this.quoteMessage.id,
					type: this.quoteMessage.type,
					content: this.quoteMessage.content,
					sendId: this.quoteMessage.sendId,
					sendNickName: this.quoteMessage.sendNickName || this.showName(this.quoteMessage)
				};
				msgInfo.quoteMessage = localQuote;
				this.quoteMessage = null;
			}
			// 填充对方id
			this.fillTargetId(msgInfo, this.chat.targetId);
				this.sendMessageRequest(msgInfo).then(m => {
					m.selfSend = true;
					this.ensureLocalGroupReceiptStats(m);
					// 若后端未回传引用信息，则用本地缓存补齐
					if (localQuote && !m.quoteMessage) {
						m.quoteMessage = localQuote;
				}
				this.chatStore.insertMessage(m, this.chat);
				// 会话置顶
				this.moveChatToTop();
				// 保持输入框焦点
				this.$refs.chatInputEditor.focus();
				// 滚动到底部
				this.scrollToBottom();
				// 关闭录音窗口
				this.showRecord = false;
				this.isReceipt = false;
				this.refreshPlaceHolder();
			})
		},
		onForwardComplete(msgInfo) {
			this.chatStore.insertMessage(msgInfo, this.chat);
			this.moveChatToTop();
			this.scrollToBottom();
		},
		fillTargetId(msgInfo, targetId) {
			if (this.chat.type == "GROUP") {
				msgInfo.groupId = targetId;
			} else {
				msgInfo.recvId = targetId;
			}
		},
		onInputEmptyChange(isEmpty) {
			this.isInputEmpty = isEmpty;
		},
		hasUserMessageContent(fullList) {
			if (!Array.isArray(fullList)) {
				return false;
			}
			return fullList.some(msg => {
				if (!msg) {
					return false;
				}
				if (msg.type !== 'text') {
					return true;
				}
				return String(msg.content || '').trim() !== '' || (Array.isArray(msg.atUserIds) && msg.atUserIds.length > 0);
			});
		},
		isQuotedEmptyTextSubmit(fullList) {
			return this.quoteMessage && !this.hasUserMessageContent(fullList);
		},
		notifySend() {
			if (!this.canSendMessage) {
				return;
			}
			this.$refs.chatInputEditor.submit();
		},
		onChangeSendMode(mode) {
			this.sendMode = mode;
			try {
				localStorage.setItem('im_send_mode', mode);
			} catch (e) {
				// ignore storage error
			}
		},
		async sendMessage(fullList) {
			if (this.isQuotedEmptyTextSubmit(fullList)) {
				return;
			}
			this.resetEditor();
			this.readedMessage();
			// 检查是否被封禁
			if (this.isBanned) {
				this.showBannedTip();
				return;
			}
				let sendText = this.chat.type == "GROUP" ? "" : (this.isReceipt ? "【回执消息】" : "");
			fullList.forEach(async msg => {
				switch (msg.type) {
					case "text":
						await this.sendTextMessage(sendText + msg.content, msg.atUserIds, msg.content);
						break;
					case "image":
						await this.sendImageMessage(msg.content.file);
						break;
					case "file":
						await this.sendFileMessage(msg.content.file);
						break;
				}
			})
		},
		sendImageMessage(file) {
			return new Promise((resolve, reject) => {
				this.onImageBefore(file);
				let formData = new FormData()
				formData.append('file', file)
				this.$http.post("/image/upload", formData, {
					headers: {
						'Content-Type': 'multipart/form-data'
					}
				}).then((data) => {
					this.onImageSuccess(data, file);
					resolve();
				}).catch((res) => {
					this.onImageFail(res, file);
					reject();
				})
				this.$nextTick(() => this.$refs.chatInputEditor.focus());
				this.scrollToBottom();
			});
		},
		sendTextMessage(sendText, atUserIds, userContent = sendText) {
			if (this.quoteMessage && String(userContent || '').trim() === '') {
				return Promise.resolve();
			}
			// 发送前缓存本地引用，防止后端未回传导致丢失
			let localQuote = null;
			if (this.quoteMessage) {
				localQuote = {
					id: this.quoteMessage.id,
					type: this.quoteMessage.type,
					content: this.quoteMessage.content,
					sendId: this.quoteMessage.sendId,
					sendNickName: this.quoteMessage.sendNickName || this.showName(this.quoteMessage)
				};
			}
			const clientMsgId = this.generateClientMsgId();
			let msgInfo = {
				id: 0,
				tmpId: clientMsgId,
				clientMsgId,
				sendId: this.mine.id,
				sendTime: new Date().getTime(),
				content: sendText,
				type: this.$enums.MESSAGE_TYPE.TEXT,
				status: this.$enums.MESSAGE_STATUS.UNSEND,
				selfSend: true,
				loadStatus: 'ok',
				localSendStatus: 'pending'
			};
			if (localQuote) {
				msgInfo.quoteMessage = localQuote;
				this.quoteMessage = null;
			}
			// 填充对方id
			this.fillTargetId(msgInfo, this.chat.targetId);
			// 被@人员列表
			if (this.chat.type == "GROUP") {
				msgInfo.atUserIds = atUserIds;
				msgInfo.receipt = this.buildReceiptEnabled();
			}
			this.ensureLocalGroupReceiptStats(msgInfo);
			// 普通消息先本地显示；正常网络下不展示发送中标识。
			this.chatStore.insertMessage(msgInfo, this.chat);
			this.moveChatToTop();
			this.scrollToBottom();
			this.isReceipt = false;
			this.startTextSendTask(msgInfo, this.chat, false);
			return Promise.resolve();
		},
		sendFileMessage(file) {
			return new Promise((resolve, reject) => {
				let check = this.$refs.fileUpload.beforeUpload(file);
				if (check) {
					this.$refs.fileUpload.onFileUpload({ file });
				}
			})
		},
		deleteMessage(msgInfo) {
			this.$confirm(DELETE_MESSAGE_CONFIRM_CONTENT, DELETE_MESSAGE_CONFIRM_TITLE, {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.chatStore.deleteMessage(msgInfo, this.chat);
			});
		},
		recallMessage(msgInfo) {
			this.$confirm('确认撤回消息?', '撤回消息', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				let url = `/message/${this.chat.type.toLowerCase()}/recall/${msgInfo.id}`
				this.$http({
					url: url,
					method: 'delete'
				}).then((m) => {
					this.$message.success("消息已撤回");
					m.selfSend = true;
					this.chatStore.recallMessage(m, this.chat);
				})
			});
		},
		forwardMessage(msgInfo) {
			this.forwardMsg = msgInfo;
			this.forwardBatch = null;
			this.showForwardSelect = true;
		},
		openFavoritePicker() {
			this.favoritePanelMode = 'picker';
			this.showFavoritePanel = true;
		},
		closeFavoritePanel() {
			this.showFavoritePanel = false;
		},
		favoriteMessage(msgInfo) {
			if (!msgInfo || !msgInfo.id) {
				this.$message.warning('只能收藏已发送成功的消息');
				return;
			}
			this.$http({
				url: '/favorite',
				method: 'POST',
				data: {
					sourceType: this.chat.type,
					messageId: msgInfo.id
				}
			}).then(() => {
				this.$message.success('已收藏');
			}).catch(() => {
				this.$message.error('收藏失败');
			});
		},
		sendFavoriteMessage(favorite) {
			if (!favorite) {
				return;
			}
			const content = favorite.content || (favorite.contentSnapshot && favorite.contentSnapshot.content);
			const type = favorite.messageType !== undefined && favorite.messageType !== null ? favorite.messageType : favorite.type;
			if (!content && content !== '') {
				this.$message.warning('收藏内容为空');
				return;
			}
			let msgInfo = {
				content,
				type,
				receipt: this.buildReceiptEnabled()
			};
			this.fillTargetId(msgInfo, this.chat.targetId);
			this.sendMessageRequest(msgInfo).then((m) => {
				m.selfSend = true;
				this.ensureLocalGroupReceiptStats(m);
				this.chatStore.insertMessage(m, this.chat);
				this.moveChatToTop();
				this.scrollToBottom();
				this.isReceipt = false;
				this.closeFavoritePanel();
			});
		},
		isSelectedMessage(msgInfo) {
			return !!msgInfo && this.selectedMessageIds.indexOf(msgInfo.id) >= 0;
		},
		enterMultiSelect(msgInfo) {
			this.resourceSelectionMode = false;
			this.selectionMode = true;
			this.selectedMessageIds = [];
			this.toggleSelectedMessage(msgInfo);
		},
		toggleSelectedMessage(msgInfo) {
			if (!msgInfo || !msgInfo.id || !this.$msgType.isNormal(msgInfo.type)) {
				return;
			}
			const index = this.selectedMessageIds.indexOf(msgInfo.id);
			if (index >= 0) {
				this.selectedMessageIds.splice(index, 1);
			} else {
				this.selectedMessageIds.push(msgInfo.id);
			}
		},
		getSelectedMessages() {
			const ids = new Set(this.selectedMessageIds);
			return (this.chat.messages || []).filter(msg => ids.has(msg.id));
		},
		cancelMultiSelect() {
			this.selectionMode = false;
			this.resourceSelectionMode = false;
			this.selectedMessageIds = [];
			this.showBatchForwardMenu = false;
		},
		buildForwardTargetChat(friend) {
			return {
				type: 'PRIVATE',
				targetId: friend.id,
				showName: friend.remarkNickName || friend.showNickName || friend.nickName,
				headImage: friend.headImageThumb || friend.headImage
			};
		},
		isForwardTargetActive(friend) {
			return !!friend && this.chat && this.chat.type === 'PRIVATE' && friend.id == this.chat.targetId;
		},
		onBatchForwarded(payload) {
			const friend = payload && payload.friend ? payload.friend : payload;
			const messages = payload && Array.isArray(payload.messages) ? payload.messages : [];
			if (friend && friend.id && messages.length) {
				const targetChat = this.buildForwardTargetChat(friend);
				this.chatStore.openChat(targetChat);
				messages.forEach((msg) => {
					if (!msg) {
						return;
					}
					msg.selfSend = true;
					this.chatStore.insertMessage(msg, targetChat);
				});
				if (this.isForwardTargetActive(friend)) {
					this.$nextTick(() => {
						this.scrollToBottom();
					});
				}
			}
			this.cancelMultiSelect();
		},
		batchForwardMessages() {
			const messages = this.getSelectedMessages();
			if (!messages.length) {
				this.$message.warning('请选择消息');
				return;
			}
			this.showBatchForwardMenu = !this.showBatchForwardMenu;
		},
		forwardBatchAs(mode) {
			const messages = this.getSelectedMessages();
			if (!messages.length) {
				this.$message.warning('请选择消息');
				return;
			}
			this.forwardMsg = {};
			this.forwardBatch = {
				mode: mode === 'merged' ? 'merged' : 'separate',
				messages: messages.map(msg => ({
					content: msg.content,
					type: msg.type,
					sendTime: msg.sendTime,
					sendNickName: msg.sendNickName || this.showName(msg),
					text: this.getQuoteText(msg)
				})),
				mergedContent: mode === 'merged' ? this.buildMergedForwardMessage() : ''
			};
			this.showBatchForwardMenu = false;
			this.showForwardSelect = true;
		},
		buildMergedForwardMessage() {
			const messages = this.getSelectedMessages();
			const records = messages.map(msg => ({
				sendNickName: msg.sendNickName || this.showName(msg),
				sendTime: msg.sendTime,
				type: msg.type,
				content: msg.content,
				text: this.getQuoteText(msg)
			}));
			const title = this.chat.type === 'GROUP' ? `${this.title}的聊天记录` : `${this.chat.showName || '聊天'}的聊天记录`;
			return JSON.stringify({
				title,
				summaryLines: records.slice(0, 4).map(record => `${record.sendNickName || '未知用户'}: ${record.text || '[消息]'}`),
				records
			});
		},
		batchFavoriteMessages() {
			const messages = this.getSelectedMessages().filter(msg => msg.id > 0);
			if (!messages.length) {
				this.$message.warning('请选择已发送成功的消息');
				return;
			}
			Promise.all(messages.map(msg => this.$http({
				url: '/favorite',
				method: 'POST',
				data: {
					sourceType: this.chat.type,
					messageId: msg.id
				}
			}))).then(() => {
				this.$message.success('已收藏');
				this.cancelMultiSelect();
			}).catch(() => {
				this.$message.error('收藏失败');
			});
		},
		batchDeleteMessages() {
			const messages = this.getSelectedMessages();
			if (!messages.length) {
				this.$message.warning('请选择消息');
				return;
			}
			this.$confirm(DELETE_MESSAGE_CONFIRM_CONTENT, DELETE_MESSAGE_CONFIRM_TITLE, {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				messages.forEach(msg => this.chatStore.deleteMessage(msg, this.chat));
				this.cancelMultiSelect();
			});
		},
		cancelQuote() {
			this.quoteMessage = null;
		},
		parseQuoteContent(msgInfo) {
			if (!msgInfo || !msgInfo.content) {
				return {};
			}
			if (typeof msgInfo.content === 'object') {
				return msgInfo.content;
			}
			try {
				return JSON.parse(msgInfo.content);
			} catch (e) {
				return {};
			}
		},
		getQuoteImageSrc(msgInfo) {
			if (!msgInfo || msgInfo.type != this.$enums.MESSAGE_TYPE.IMAGE) {
				return '';
			}
			const data = this.parseQuoteContent(msgInfo);
			return data.thumbUrl || data.originUrl || data.url || '';
		},
		isQuoteImage(msgInfo) {
			return msgInfo && msgInfo.type == this.$enums.MESSAGE_TYPE.IMAGE && !!this.getQuoteImageSrc(msgInfo);
		},
		isQuoteLocation(msgInfo) {
			return msgInfo && msgInfo.type == this.$enums.MESSAGE_TYPE.LOCATION;
		},
		getQuoteLocationData(msgInfo) {
			if (!this.isQuoteLocation(msgInfo)) {
				return null;
			}
			const data = this.parseQuoteContent(msgInfo);
			const latitude = Number(data.latitude);
			const longitude = Number(data.longitude);
			return {
				...data,
				latitude,
				longitude,
				validCoordinates: Number.isFinite(latitude) && Number.isFinite(longitude)
					&& latitude >= -90 && latitude <= 90
					&& longitude >= -180 && longitude <= 180
					&& !(latitude === 0 && longitude === 0)
			};
		},
		getQuoteLocationText(msgInfo) {
			const data = this.getQuoteLocationData(msgInfo);
			return (data && (data.name || data.address)) || '位置';
		},
		getQuoteLocationMapUrl(msgInfo) {
			const data = this.getQuoteLocationData(msgInfo);
			const mapUrl = process.env.VUE_APP_AMAP_STATIC_MAP_URL;
			const mapKey = process.env.VUE_APP_AMAP_KEY;
			if (!data || !data.validCoordinates || !mapUrl || !mapKey) {
				return '';
			}
			const params = new URLSearchParams({
				location: `${data.longitude},${data.latitude}`,
				zoom: '15',
				size: '160*100',
				scale: '2',
				key: mapKey,
				markers: `mid,,A:${data.longitude},${data.latitude}`
			});
			return `${mapUrl}?${params.toString()}`;
		},
		isQuoteFile(msgInfo) {
			return msgInfo && (msgInfo.type == this.$enums.MESSAGE_TYPE.FILE
				|| msgInfo.type == this.$enums.MESSAGE_TYPE.VIDEO);
		},
		isQuoteFriendCard(msgInfo) {
			return msgInfo && msgInfo.type == this.$enums.MESSAGE_TYPE.FRIEND_CARD;
		},
		isQuoteMergedForward(msgInfo) {
			return msgInfo && msgInfo.type == this.$enums.MESSAGE_TYPE.MERGED_FORWARD;
		},
		getQuoteTypeLabel(msgInfo) {
			if (!msgInfo) return '';
			if (msgInfo.quoteMessage) return '[引用]';
			const labels = {
				[this.$enums.MESSAGE_TYPE.FILE]: '[文件]',
				[this.$enums.MESSAGE_TYPE.AUDIO]: '[语音]',
				[this.$enums.MESSAGE_TYPE.VIDEO]: '[文件]',
				[this.$enums.MESSAGE_TYPE.LOCATION]: '[位置]',
				[this.$enums.MESSAGE_TYPE.FRIEND_CARD]: '[名片]',
				[this.$enums.MESSAGE_TYPE.MERGED_FORWARD]: '[引用]'
			};
			return labels[msgInfo.type] || '';
		},
		getQuoteBodyText(msgInfo) {
			if (!msgInfo) return '';
			if (this.isQuoteMergedForward(msgInfo)) {
				return this.getQuoteMergedForwardTitle(msgInfo);
			}
			if (msgInfo.type == this.$enums.MESSAGE_TYPE.IMAGE
				|| msgInfo.type == this.$enums.MESSAGE_TYPE.AUDIO
				|| msgInfo.type == this.$enums.MESSAGE_TYPE.VIDEO
				|| msgInfo.type == this.$enums.MESSAGE_TYPE.LOCATION) {
				return '';
			}
			return this.getQuoteText(msgInfo);
		},
		isTwoLineQuote(msgInfo) {
			return !!(msgInfo && (msgInfo.quoteMessage
				|| msgInfo.type != this.$enums.MESSAGE_TYPE.TEXT));
		},
		getQuoteMergedForwardTitle(msgInfo) {
			const data = this.parseQuoteContent(msgInfo);
			return data.title || msgInfo.title || '聊天记录';
		},
		getQuoteMergedForwardText(msgInfo) {
			return `[引用]${this.getQuoteMergedForwardTitle(msgInfo)}`;
		},
		getQuoteFileIconMeta(msgInfo) {
			return getFileIconMetaFromContent(msgInfo && msgInfo.content);
		},
		isRichQuote(msgInfo) {
			return this.isQuoteImage(msgInfo) || this.isQuoteFile(msgInfo)
				|| this.isQuoteFriendCard(msgInfo) || this.isQuoteLocation(msgInfo);
		},
		getQuoteFriendCard(msgInfo) {
			const data = this.parseQuoteContent(msgInfo);
			return data.card || data.friend || data.user || data;
		},
		getQuoteFriendCardAvatar(msgInfo) {
			const data = this.getQuoteFriendCard(msgInfo);
			return data.headImageThumb || data.headImage || data.avatar || data.portrait || data.url || '';
		},
		getQuoteFriendCardName(msgInfo) {
			const data = this.getQuoteFriendCard(msgInfo);
			return data.nickName || data.showNickName || data.name || data.userName || data.username || '个人名片';
		},
		getRichQuoteText(msgInfo) {
			if (this.isQuoteImage(msgInfo)) {
				return '[图片]';
			}
			if (this.isQuoteFriendCard(msgInfo)) {
				return this.getQuoteFriendCardName(msgInfo);
			}
			if (this.isQuoteFile(msgInfo)) {
				const data = this.parseQuoteContent(msgInfo);
				return data.name || '文件';
			}
			if (this.isQuoteLocation(msgInfo)) {
				return this.getQuoteLocationText(msgInfo);
			}
			return this.getQuoteText(msgInfo);
		},
		getQuoteText(msgInfo) {
			if (!msgInfo) return '';
			if (msgInfo.type == this.$enums.MESSAGE_TYPE.TEXT) {
				let text = msgInfo.content || '';
				text = text.replace(/<[^>]+>/g, '');
				text = text.replace(/#[^;]+;/g, '');
				text = text.replace(/【回执消息】/g, '');
				if (text.length > 50) {
					text = text.substring(0, 50) + '...';
				}
				return text || '[文本]';
			} else if (msgInfo.type == this.$enums.MESSAGE_TYPE.IMAGE) {
				return '[图片]';
			} else if (msgInfo.type == this.$enums.MESSAGE_TYPE.FILE) {
				try {
					const data = JSON.parse(msgInfo.content);
					return `[文件] ${data.name || '文件'}`;
				} catch (e) {
					return '[文件]';
				}
			} else if (msgInfo.type == this.$enums.MESSAGE_TYPE.FRIEND_CARD) {
				return `[名片] ${this.getQuoteFriendCardName(msgInfo)}`.trim();
			} else if (this.isQuoteMergedForward(msgInfo)) {
				return this.getQuoteMergedForwardText(msgInfo);
			} else if (msgInfo.type == this.$enums.MESSAGE_TYPE.AUDIO) {
				return '[语音]';
			} else if (msgInfo.type == this.$enums.MESSAGE_TYPE.VIDEO) {
				return '[文件]';
			} else if (msgInfo.type == this.$enums.MESSAGE_TYPE.LOCATION) {
				return `[位置] ${this.getQuoteLocationText(msgInfo)}`;
			}
			return '[消息]';
		},
		readedMessage() {
			if (this.chat.unreadCount == 0) {
				return;
			}
			this.chatStore.resetUnreadCount(this.chat)
			if (this.chat.type == "GROUP") {
				var url = `/message/group/readed?groupId=${this.chat.targetId}`
			} else {
				url = `/message/private/readed?friendId=${this.chat.targetId}`
			}
			this.$http({
				url: url,
				method: 'put'
			}).then(() => { })
		},
		loadReaded(fId) {
			this.$http({
				url: `/message/private/maxReadedId?friendId=${fId}`,
				method: 'get'
			}).then((id) => {
				this.chatStore.readedMessage({
					friendId: fId,
					maxId: id
				});
			});
		},
		loadGroup(groupId) {
			this.$http({
				url: `/group/find/${groupId}`,
				method: 'get'
			}).then((group) => {
				this.group = group;
				this.chatStore.updateChatFromGroup(group);
				this.groupStore.updateGroup(group);
			});

			this.$http({
				url: `/group/members/${groupId}`,
				method: 'get'
			}).then((groupMembers) => {
				this.groupMembers = groupMembers;
				this.$nextTick(() => this.refreshGroupReceiptStats());
			});
		},
		updateFriendInfo() {
			if (this.isFriend) {
				// store的数据不能直接修改，深拷贝一份store的数据
				let friend = JSON.parse(JSON.stringify(this.friend));
				friend.headImage = this.userInfo.headImageThumb;
				friend.nickName = this.userInfo.nickName;
				friend.showNickName = friend.remarkNickName ? friend.remarkNickName : friend.nickName;
				this.chatStore.updateChatFromFriend(friend);
				this.friendStore.updateFriend(friend);
			} else {
				this.chatStore.updateChatFromUser(this.userInfo);
			}
		},
		loadFriend(friendId) {
			// 获取好友信息
			this.$http({
				url: `/user/find/${friendId}`,
				method: 'GET'
			}).then((userInfo) => {
				this.userInfo = userInfo;
				this.updateFriendInfo();
			})
		},
		showName(msgInfo) {
			if (!msgInfo) {
				return ""
			}
			if (this.isGroup) {
				let member = this.groupMembers.find((m) => m.userId == msgInfo.sendId);
				return member ? member.showNickName : msgInfo.sendNickName || "";
			} else {
				return msgInfo.selfSend ? this.mine.nickName : this.chat.showName
			}
		},
		originalName(msgInfo) {
			if (!msgInfo) {
				return ""
			}
			if (this.isGroup) {
				let member = this.groupMembers.find((m) => m.userId == msgInfo.sendId);
				return member ? member.nickName : msgInfo.sendNickName || "";
			} else {
				return msgInfo.selfSend ? this.mine.nickName : (this.chat.originalName || this.chat.showName)
			}
		},
		headImage(msgInfo) {
			if (this.isGroup) {
				let member = this.groupMembers.find((m) => m.userId == msgInfo.sendId);
				return member ? member.headImage : "";
			} else {
				return msgInfo.sendId == this.mine.id ? this.mine.headImageThumb : this.chat.headImage
			}
		},
		messageUserId(msgInfo) {
			if (!msgInfo) {
				return null;
			}
			return msgInfo.sendId || (msgInfo.selfSend ? this.mine.id : null);
		},
		resetEditor() {
			this.$nextTick(() => {
				this.$refs.chatInputEditor.clear();
				this.$refs.chatInputEditor.focus();
			});
		},
		scrollToBottom() {
			this.$nextTick(() => {
				let div = document.getElementById("chatScrollBox");
				div.scrollTop = div.scrollHeight;
			});
		},
			refreshPlaceHolder() {
				if (this.isReceipt && this.chat.type !== "GROUP") {
					this.placeholder = "【回执消息】"
				} else if (this.$refs.editBox && this.$refs.editBox.innerHTML) {
				this.placeholder = ""
			} else {
				this.placeholder = "聊点什么吧~";
			}
		},
		sendMessageRequest(msgInfo, options = {}) {
			return new Promise((resolve, reject) => {
				// 请求入队列，防止请求"后发先至"，导致消息错序
				this.reqQueue.push({
					msgInfo,
					resolve,
					reject,
					silent: !!options.silent,
					action: options.action || this.messageAction,
					shouldSend: options.shouldSend
				});
				this.processReqQueue();
			})
		},
		processReqQueue() {
			if (this.isSending) {
				return;
			}
			while (this.reqQueue.length) {
				const reqData = this.reqQueue.shift();
				if (reqData.shouldSend && !reqData.shouldSend()) {
					reqData.reject({ code: 'SEND_CANCELLED', message: '发送任务已结束' });
					continue;
				}
				this.isSending = true;
				this.$http({
					url: reqData.action,
					method: 'post',
					data: reqData.msgInfo,
					silent: reqData.silent
				}).then((res) => {
					reqData.resolve(res)
				}).catch((e) => {
					reqData.reject(e)
				}).finally(() => {
					this.isSending = false;
					// 发送下一条请求
					this.processReqQueue();
				})
				return;
			}
		},
		showBannedTip() {
			let msgInfo = {
				tmpId: this.generateId(),
				sendId: this.mine.id,
				sendTime: new Date().getTime(),
				type: this.$enums.MESSAGE_TYPE.TIP_TEXT
			}
			if (this.chat.type == "PRIVATE") {
				msgInfo.recvId = this.mine.id
				msgInfo.content = "该用户已被管理员封禁,原因:" + this.userInfo.reason
			} else {
				msgInfo.groupId = this.group.id;
				msgInfo.content = "本群聊已被管理员封禁,原因:" + this.group.reason
			}
			this.chatStore.insertMessage(msgInfo, this.chat);
		},
		generateId() {
			// 生成临时id
			return String(new Date().getTime()) + String(Math.floor(Math.random() * 1000));
		},
		generateClientMsgId() {
			if (window.crypto && typeof window.crypto.randomUUID === 'function') {
				return window.crypto.randomUUID();
			}
			return `${this.mine.id || 0}-${this.generateId()}-${Math.random().toString(16).slice(2)}`;
		},
		buildTextSendPayload(msgInfo, chatInfo) {
			let payload = {
				clientMsgId: msgInfo.clientMsgId,
				content: msgInfo.content,
				type: msgInfo.type
			};
			if (msgInfo.quoteMessage) {
				payload.quoteMessage = msgInfo.quoteMessage;
			}
			if (chatInfo.type === 'GROUP') {
				payload.groupId = msgInfo.groupId || chatInfo.targetId;
				payload.atUserIds = msgInfo.atUserIds || [];
				payload.receipt = msgInfo.receipt;
			} else {
				payload.recvId = msgInfo.recvId || chatInfo.targetId;
			}
			return payload;
		},
		resolveTextSendRetryWindow() {
			const configuredSeconds = Number(this.configStore && this.configStore.message &&
				this.configStore.message.sendRetryTimeoutSeconds);
			return Number.isFinite(configuredSeconds) && configuredSeconds > 0
				? Math.floor(configuredSeconds * 1000)
				: DEFAULT_TEXT_SEND_RETRY_WINDOW;
		},
		startTextSendTask(msgInfo, chatInfo, showSending) {
			const clientMsgId = msgInfo.clientMsgId || msgInfo.tmpId;
			if (!clientMsgId) {
				return;
			}
			const oldTask = this.pendingTextSends[clientMsgId];
			if (oldTask) {
				oldTask.superseded = true;
				this.clearTextSendTimers(oldTask);
			}
			const retryWindow = this.resolveTextSendRetryWindow();
			const task = {
				clientMsgId,
				message: msgInfo,
				chat: chatInfo,
				payload: this.buildTextSendPayload(msgInfo, chatInfo),
				deadline: Date.now() + retryWindow,
				retryCount: 0,
				inFlight: false,
				completed: false,
				expired: false,
				superseded: false,
				retryTimer: null,
				deadlineTimer: null
			};
			this.pendingTextSends[clientMsgId] = task;
			if (showSending) {
				this.setTextSendState(task, 'retrying', 'loading');
			}
			task.deadlineTimer = setTimeout(() => this.expireTextSendTask(task), retryWindow);
			this.attemptTextSend(task);
		},
		attemptTextSend(task) {
			if (!task || task.completed || task.expired || task.superseded || task.inFlight) {
				return;
			}
			if (Date.now() >= task.deadline) {
				this.expireTextSendTask(task);
				return;
			}
			if (typeof navigator !== 'undefined' && navigator.onLine === false) {
				this.setTextSendState(task, 'retrying', 'loading');
				this.scheduleTextSendRetry(task, TEXT_SEND_OFFLINE_RETRY_DELAY);
				return;
			}
			task.inFlight = true;
			this.sendMessageRequest(task.payload, {
				silent: true,
				action: `/message/${task.chat.type.toLowerCase()}/send`,
				shouldSend: () => !task.completed && !task.expired && !task.superseded
			}).then((serverMessage) => {
				this.completeTextSendTask(task, serverMessage);
			}).catch((error) => {
				if (task.completed || task.superseded) {
					return;
				}
				if (this.isTextSendRetriableError(error) && Date.now() < task.deadline) {
					task.retryCount++;
					this.setTextSendState(task, 'retrying', 'loading');
					const delay = Math.min(1000 * Math.pow(2, Math.max(task.retryCount - 1, 0)), TEXT_SEND_MAX_RETRY_DELAY);
					this.scheduleTextSendRetry(task, delay);
				} else {
					this.failTextSendTask(task, error);
				}
			}).finally(() => {
				task.inFlight = false;
				if ((task.expired || task.superseded) && this.pendingTextSends[task.clientMsgId] === task) {
					delete this.pendingTextSends[task.clientMsgId];
				}
			});
		},
		completeTextSendTask(task, serverMessage) {
			if (!task || task.completed || task.superseded || !serverMessage) {
				return;
			}
			task.completed = true;
			this.clearTextSendTimers(task);
			let confirmedMessage = Object.assign({}, task.message, serverMessage, {
				tmpId: task.message.tmpId,
				clientMsgId: task.clientMsgId,
				selfSend: true,
				loadStatus: 'ok',
				localSendStatus: 'success'
			});
			if (task.message.quoteMessage && !confirmedMessage.quoteMessage) {
				confirmedMessage.quoteMessage = task.message.quoteMessage;
			}
			this.ensureLocalGroupReceiptStats(confirmedMessage);
			this.chatStore.insertMessage(confirmedMessage, task.chat);
			if (this.pendingTextSends[task.clientMsgId] === task) {
				delete this.pendingTextSends[task.clientMsgId];
			}
		},
		setTextSendState(task, localSendStatus, loadStatus) {
			if (!task || task.completed || task.superseded) {
				return;
			}
			this.chatStore.updateMessage({
				tmpId: task.message.tmpId,
				clientMsgId: task.clientMsgId,
				localSendStatus,
				loadStatus
			}, task.chat);
		},
		scheduleTextSendRetry(task, delay) {
			if (!task || task.completed || task.expired || task.superseded) {
				return;
			}
			if (task.retryTimer) {
				clearTimeout(task.retryTimer);
			}
			const remaining = Math.max(task.deadline - Date.now(), 0);
			if (!remaining) {
				this.expireTextSendTask(task);
				return;
			}
			task.retryTimer = setTimeout(() => {
				task.retryTimer = null;
				this.attemptTextSend(task);
			}, Math.min(delay, remaining));
		},
		isTextSendRetriableError(error) {
			// 业务错误(code 为数字)属于明确拒绝；断网、超时、限流和 5xx 才进入重试。
			if (error && typeof error.code === 'number') {
				return false;
			}
			const status = error && error.response ? error.response.status : null;
			if (!status) {
				return true;
			}
			return status === 408 || status === 429 || status >= 500;
		},
		failTextSendTask(task, error) {
			if (!task || task.completed || task.superseded) {
				return;
			}
			task.expired = true;
			this.clearTextSendTimers(task);
			this.setTextSendState(task, 'fail', 'fail');
			if (error && error.message) {
				this.$message.error(error.message);
			}
			if (!task.inFlight && this.pendingTextSends[task.clientMsgId] === task) {
				delete this.pendingTextSends[task.clientMsgId];
			}
		},
		expireTextSendTask(task) {
			this.failTextSendTask(task);
		},
		clearTextSendTimers(task) {
			if (!task) {
				return;
			}
			if (task.retryTimer) {
				clearTimeout(task.retryTimer);
				task.retryTimer = null;
			}
			if (task.deadlineTimer) {
				clearTimeout(task.deadlineTimer);
				task.deadlineTimer = null;
			}
		},
		retryPendingTextMessages() {
			Object.keys(this.pendingTextSends).forEach((clientMsgId) => {
				const task = this.pendingTextSends[clientMsgId];
				if (!task || task.completed || task.expired || task.superseded) {
					return;
				}
				if (task.retryTimer) {
					clearTimeout(task.retryTimer);
					task.retryTimer = null;
				}
				this.attemptTextSend(task);
			});
		},
		retryTextMessage(msgInfo) {
			if (!msgInfo || msgInfo.type !== this.$enums.MESSAGE_TYPE.TEXT || !msgInfo.clientMsgId) {
				return;
			}
			this.startTextSendTask(msgInfo, this.chat, true);
		},

		onScreenshot() {
			// 添加 html2canvas 导入检查
			const html2canvas = window.html2canvas;
			if (!html2canvas) {
				console.error('html2canvas 未加载，请确保已引入该库');
				return;
			}

			// 保存 this 引用
			const self = this;

			console.log('开始截图模式...');

			// 创建遮罩层
			const overlay = document.createElement('div');
			overlay.style.position = 'fixed';
			overlay.style.left = '0';
			overlay.style.top = '0';
			overlay.style.right = '0';
			overlay.style.bottom = '0';
			overlay.style.backgroundColor = 'transparent';
			overlay.style.zIndex = '9998';
			overlay.style.cursor = 'crosshair';
			document.body.appendChild(overlay);
			console.log('遮罩层已创建');

			const selectionHint = document.createElement('div');
			selectionHint.className = 'screenshot-selection-hint';
			selectionHint.textContent = '拖拽选择截图区域，Esc 退出';
			selectionHint.style.position = 'fixed';
			selectionHint.style.left = '50%';
			selectionHint.style.top = '24px';
			selectionHint.style.transform = 'translateX(-50%)';
			selectionHint.style.zIndex = '10001';
			selectionHint.style.display = 'inline-flex';
			selectionHint.style.alignItems = 'center';
			selectionHint.style.justifyContent = 'center';
			selectionHint.style.height = '34px';
			selectionHint.style.padding = '0 16px';
			selectionHint.style.borderRadius = '999px';
			selectionHint.style.background = 'rgba(15, 23, 42, 0.82)';
			selectionHint.style.color = '#ffffff';
			selectionHint.style.fontSize = '13px';
			selectionHint.style.fontWeight = '500';
			selectionHint.style.letterSpacing = '0';
			selectionHint.style.boxShadow = '0 12px 30px rgba(15, 23, 42, 0.24)';
			selectionHint.style.backdropFilter = 'blur(12px)';
			selectionHint.style.webkitBackdropFilter = 'blur(12px)';
			selectionHint.style.pointerEvents = 'none';
			document.body.appendChild(selectionHint);

			// 创建选区矩形（可视化选框）
			const selectionBox = document.createElement('div');
			selectionBox.className = 'screenshot-selection-box';
			selectionBox.style.position = 'fixed';
			selectionBox.style.border = '2px solid #4f8cff';
			selectionBox.style.borderRadius = '4px';
			selectionBox.style.backgroundColor = 'rgba(79, 140, 255, 0.08)';
			selectionBox.style.boxShadow = '0 0 0 99999px rgba(15, 23, 42, 0.42), inset 0 0 0 1px rgba(255, 255, 255, 0.92), 0 12px 34px rgba(15, 23, 42, 0.20)';
			selectionBox.style.boxSizing = 'border-box';
			selectionBox.style.pointerEvents = 'none';
			selectionBox.style.display = 'none';
			selectionBox.style.zIndex = '9999';
			document.body.appendChild(selectionBox);

			const selectionSizeBadge = document.createElement('span');
			selectionSizeBadge.className = 'screenshot-size-badge';
			selectionSizeBadge.style.position = 'absolute';
			selectionSizeBadge.style.left = '0';
			selectionSizeBadge.style.bottom = '-30px';
			selectionSizeBadge.style.display = 'none';
			selectionSizeBadge.style.alignItems = 'center';
			selectionSizeBadge.style.height = '22px';
			selectionSizeBadge.style.padding = '0 8px';
			selectionSizeBadge.style.borderRadius = '6px';
			selectionSizeBadge.style.background = 'rgba(15, 23, 42, 0.86)';
			selectionSizeBadge.style.color = '#ffffff';
			selectionSizeBadge.style.fontSize = '12px';
			selectionSizeBadge.style.fontWeight = '600';
			selectionSizeBadge.style.lineHeight = '22px';
			selectionSizeBadge.style.boxShadow = '0 6px 16px rgba(15, 23, 42, 0.22)';
			selectionBox.appendChild(selectionSizeBadge);

			const selectionHandlePositions = ['nw', 'n', 'ne', 'e', 'se', 's', 'sw', 'w'];
			selectionHandlePositions.forEach((position) => {
				const handle = document.createElement('span');
				handle.className = `screenshot-selection-handle screenshot-selection-handle-${position}`;
				handle.style.position = 'absolute';
				handle.style.width = '8px';
				handle.style.height = '8px';
				handle.style.border = '2px solid #4f8cff';
				handle.style.borderRadius = '50%';
				handle.style.background = '#ffffff';
				handle.style.boxShadow = '0 2px 8px rgba(15, 23, 42, 0.20)';
				handle.style.boxSizing = 'border-box';
				if (position.includes('n')) handle.style.top = '-5px';
				if (position.includes('s')) handle.style.bottom = '-5px';
				if (position.includes('w')) handle.style.left = '-5px';
				if (position.includes('e')) handle.style.right = '-5px';
				if (position === 'n' || position === 's') {
					handle.style.left = '50%';
					handle.style.transform = 'translateX(-50%)';
				}
				if (position === 'e' || position === 'w') {
					handle.style.top = '50%';
					handle.style.transform = 'translateY(-50%)';
				}
				selectionBox.appendChild(handle);
			});

			// 创建一个用于绘制的canvas，覆盖在选区之上
			const drawCanvas = document.createElement('canvas');
			const drawCtx = drawCanvas.getContext('2d');
			drawCanvas.style.position = 'fixed';
			drawCanvas.style.zIndex = '9999';
			drawCanvas.style.pointerEvents = 'none'; // 默认不响应鼠标事件
			drawCanvas.style.display = 'none';
			document.body.appendChild(drawCanvas);

			// 创建工具条（圆角条，使用 Web 主色浅蓝）
			const toolbar = document.createElement('div');
			toolbar.style.position = 'fixed';
			toolbar.style.display = 'none';
			toolbar.style.zIndex = '10000'; // 比drawCanvas高
			toolbar.style.background = 'rgba(255, 255, 255, 0.94)';
			toolbar.style.padding = '8px';
			toolbar.style.borderRadius = '14px';
			toolbar.style.boxShadow = '0 18px 44px rgba(15, 23, 42, 0.20), 0 2px 8px rgba(15, 23, 42, 0.08)';
			toolbar.style.color = '#1f2937';
			toolbar.style.border = '1px solid rgba(148, 163, 184, 0.35)';
			toolbar.style.backdropFilter = 'blur(18px)';
			toolbar.style.webkitBackdropFilter = 'blur(18px)';
			toolbar.style.fontFamily = 'Arial, sans-serif';
			toolbar.style.fontSize = '14px';
			// toolbar.style.display = 'flex';
			toolbar.style.alignItems = 'center';
			toolbar.style.gap = '6px';
			toolbar.style.userSelect = 'none';
			document.body.appendChild(toolbar);
			console.log('工具条已创建');

			// 创建文本输入框
			const textBox = document.createElement('textarea');
			textBox.style.position = 'fixed';
			textBox.style.zIndex = '2147483647'; // 最大z-index
			textBox.style.display = 'none';
			textBox.style.background = 'transparent';
			textBox.style.border = 'none';
			textBox.style.outline = 'none';
			textBox.style.boxShadow = 'none';
			textBox.style.color = '#ffffff';
			textBox.style.padding = '0';
			textBox.style.fontSize = '16px';
			textBox.style.lineHeight = '1.2';
			textBox.style.resize = 'none';
			textBox.style.overflow = 'hidden';
			textBox.style.textShadow = '0 1px 4px rgba(0, 0, 0, 0.45)';
			document.body.appendChild(textBox);

			let isDown = false;
			let startX, startY;
			let lastRect = null;
			let currentMode = 'select'; // 'select', 'rect', 'arrow', 'brush', 'erase', 'text'
			let drawing = false;
			let currentPathPoints = [];
			let textInputActive = false;
			let currentAnnotateColor = '#FF3B30';
			let currentLineWidth = 4;
			let textElements = []; // 存储文本元素 {x, y, text, color, font}
			let drawElements = []; // 存储绘制元素 {type, ...}

			// 清理函数
			const cleanup = () => {
				console.log('清理截图工具');
				// 移除事件监听
				overlay.removeEventListener('mousedown', onMouseDown);
				overlay.removeEventListener('mousemove', onMouseMove);
				overlay.removeEventListener('mouseup', onMouseUp);
				overlay.removeEventListener('click', onOverlayClick); // 移除点击事件处理
				overlay.removeEventListener('dblclick', onDoubleClick);
				overlay.removeEventListener('contextmenu', preventContextMenu);
				document.removeEventListener('click', handleDocumentClick);
				document.removeEventListener('keydown', handleKeyDown);

				if (overlay.parentNode) document.body.removeChild(overlay);
				if (selectionHint.parentNode) document.body.removeChild(selectionHint);
				if (selectionBox.parentNode) document.body.removeChild(selectionBox);
				if (toolbar.parentNode) document.body.removeChild(toolbar);
				if (drawCanvas.parentNode) document.body.removeChild(drawCanvas);
				if (textBox.parentNode) document.body.removeChild(textBox);
				isDown = false;
				lastRect = null;
				currentMode = 'select';
				drawing = false;
				currentPathPoints = [];
				textInputActive = false;
				currentAnnotateColor = '#FF3B30';
				currentLineWidth = 4;
				textElements = [];
				drawElements = [];
			};

			const getAnnotationFontSize = () => 12 + currentLineWidth * 2;
			const getAnnotationFont = () => `bold ${getAnnotationFontSize()}px Arial`;
			const isPointInSelection = (x, y) => lastRect &&
				x >= lastRect.left && x <= lastRect.left + lastRect.width &&
				y >= lastRect.top && y <= lastRect.top + lastRect.height;
			const getDistanceToSegment = (px, py, x1, y1, x2, y2) => {
				const dx = x2 - x1;
				const dy = y2 - y1;
				if (dx === 0 && dy === 0) {
					return Math.hypot(px - x1, py - y1);
				}
				const t = Math.max(0, Math.min(1, ((px - x1) * dx + (py - y1) * dy) / (dx * dx + dy * dy)));
				const closestX = x1 + t * dx;
				const closestY = y1 + t * dy;
				return Math.hypot(px - closestX, py - closestY);
			};
			const drawPathOnCanvas = (ctx, points, color, lineWidth, offsetX = 0, offsetY = 0) => {
				if (!points || !points.length) {
					return;
				}
				ctx.save();
				ctx.strokeStyle = color;
				ctx.fillStyle = color;
				ctx.lineWidth = lineWidth;
				ctx.lineCap = 'round';
				ctx.lineJoin = 'round';
				if (points.length === 1) {
					ctx.beginPath();
					ctx.arc(points[0].x - offsetX, points[0].y - offsetY, Math.max(lineWidth / 2, 1), 0, Math.PI * 2);
					ctx.fill();
					ctx.restore();
					return;
				}
				ctx.beginPath();
				ctx.moveTo(points[0].x - offsetX, points[0].y - offsetY);
				for (let i = 1; i < points.length; i++) {
					ctx.lineTo(points[i].x - offsetX, points[i].y - offsetY);
				}
				ctx.stroke();
				ctx.restore();
			};
			const drawArrowOnCanvas = (ctx, el, offsetX = 0, offsetY = 0) => {
				const startX = el.startX - offsetX;
				const startY = el.startY - offsetY;
				const endX = el.endX - offsetX;
				const endY = el.endY - offsetY;
				const angle = Math.atan2(endY - startY, endX - startX);
				const headLength = Math.max(8, el.lineWidth * 3);
				ctx.save();
				ctx.strokeStyle = el.color;
				ctx.fillStyle = el.color;
				ctx.lineWidth = el.lineWidth;
				ctx.lineCap = 'round';
				ctx.lineJoin = 'round';
				ctx.beginPath();
				ctx.moveTo(startX, startY);
				ctx.lineTo(endX, endY);
				ctx.stroke();
				ctx.beginPath();
				ctx.moveTo(endX, endY);
				ctx.lineTo(endX - headLength * Math.cos(angle - Math.PI / 6), endY - headLength * Math.sin(angle - Math.PI / 6));
				ctx.lineTo(endX - headLength * Math.cos(angle + Math.PI / 6), endY - headLength * Math.sin(angle + Math.PI / 6));
				ctx.closePath();
				ctx.fill();
				ctx.restore();
			};
			const isPointNearPath = (points, x, y, tolerance) => {
				if (!points || !points.length) {
					return false;
				}
				if (points.length === 1) {
					return Math.hypot(points[0].x - x, points[0].y - y) <= tolerance;
				}
				for (let i = 1; i < points.length; i++) {
					if (getDistanceToSegment(x, y, points[i - 1].x, points[i - 1].y, points[i].x, points[i].y) <= tolerance) {
						return true;
					}
				}
				return false;
			};
			const isPointNearRect = (el, x, y, tolerance) => {
				const left = Math.min(el.x, el.x + el.width);
				const top = Math.min(el.y, el.y + el.height);
				const right = Math.max(el.x, el.x + el.width);
				const bottom = Math.max(el.y, el.y + el.height);
				if (x < left - tolerance || x > right + tolerance || y < top - tolerance || y > bottom + tolerance) {
					return false;
				}
				return true;
			};
			const isPointNearArrow = (el, x, y, tolerance) => {
				return getDistanceToSegment(x, y, el.startX, el.startY, el.endX, el.endY) <= tolerance ||
					Math.hypot(el.endX - x, el.endY - y) <= tolerance * 1.5;
			};
			const isPointInsideText = (el, x, y, tolerance) => {
				drawCtx.save();
				drawCtx.font = el.font;
				const lines = el.text.split('\n');
				const fontSize = parseInt(el.font, 10) || 16;
				const lineHeight = fontSize * 1.2;
				const maxWidth = lines.reduce((max, line) => Math.max(max, drawCtx.measureText(line).width), 0);
				drawCtx.restore();
				return x >= el.x - tolerance &&
					x <= el.x + maxWidth + tolerance &&
					y >= el.y - tolerance &&
					y <= el.y + lineHeight * lines.length + tolerance;
			};
			const eraseAtPoint = (x, y) => {
				const tolerance = Math.max(currentLineWidth, 6) + 4;
				for (let i = drawElements.length - 1; i >= 0; i--) {
					const el = drawElements[i];
					const hit = el.type === 'rect'
						? isPointNearRect(el, x, y, tolerance)
						: el.type === 'arrow'
							? isPointNearArrow(el, x, y, tolerance)
							: isPointNearPath(el.points, x, y, tolerance);
					if (hit) {
						drawElements.splice(i, 1);
						redrawDrawCanvas();
						return true;
					}
				}
				for (let i = textElements.length - 1; i >= 0; i--) {
					if (isPointInsideText(textElements[i], x, y, tolerance)) {
						textElements.splice(i, 1);
						redrawDrawCanvas();
						return true;
					}
				}
				return false;
			};

			// 绘制所有元素到drawCanvas
			const redrawDrawCanvas = () => {
				if (!lastRect) return;
				drawCtx.clearRect(0, 0, drawCanvas.width, drawCanvas.height);

				drawElements.forEach(el => {
					if (el.type === 'rect') {
						drawCtx.save();
						drawCtx.strokeStyle = el.color;
						drawCtx.lineWidth = el.lineWidth;
						drawCtx.lineJoin = 'round';
						drawCtx.strokeRect(el.x - lastRect.left, el.y - lastRect.top, el.width, el.height);
						drawCtx.restore();
					} else if (el.type === 'arrow') {
						drawArrowOnCanvas(drawCtx, el, lastRect.left, lastRect.top);
					} else if (el.type === 'brush') {
						drawPathOnCanvas(drawCtx, el.points, el.color, el.lineWidth, lastRect.left, lastRect.top);
					}
				});

				textElements.forEach(el => {
					drawCtx.save();
					drawCtx.fillStyle = el.color;
					drawCtx.font = el.font;
					drawCtx.textBaseline = 'top';
					const lines = el.text.split('\n');
					let currentY = el.y - lastRect.top;
					lines.forEach(line => {
						drawCtx.fillText(line, el.x - lastRect.left, currentY);
						currentY += parseInt(el.font, 10) * 1.2;
					});
					drawCtx.restore();
				});
			};

			const openTextInputAt = (x, y) => {
				textInputActive = true;
				lastTextBoxCreateTime = Date.now();
				textBox.style.display = 'block';
				textBox.style.left = `${x}px`;
				textBox.style.top = `${y}px`;
				textBox.style.width = 'auto';
				textBox.style.height = 'auto';
				textBox.style.minWidth = '20px';
				textBox.style.minHeight = `${Math.round(getAnnotationFontSize() * 1.4)}px`;
				textBox.style.fontSize = `${getAnnotationFontSize()}px`;
				textBox.style.lineHeight = `${Math.round(getAnnotationFontSize() * 1.2)}px`;
				textBox.style.color = currentAnnotateColor;
				textBox.style.visibility = 'visible';
				textBox.style.opacity = '1';
				textBox.value = '';
				textBox.dataset.startX = x;
				textBox.dataset.startY = y;
				setTimeout(() => textBox.focus(), 10);
			};

			const updateSelectionBoxVisual = ({ left, top, width, height }) => {
				selectionBox.style.left = `${left}px`;
				selectionBox.style.top = `${top}px`;
				selectionBox.style.width = `${width}px`;
				selectionBox.style.height = `${height}px`;
				selectionSizeBadge.textContent = `${Math.round(width)} x ${Math.round(height)}`;
				selectionSizeBadge.style.display = width >= 24 && height >= 24 ? 'inline-flex' : 'none';
			};

			// 鼠标事件处理
			const onMouseDown = (e) => {
				if (e.button !== 0) return; // 只响应左键

				if (currentMode === 'select') {
					console.log('鼠标按下 - 选择模式');
					isDown = true;
					startX = e.clientX;
					startY = e.clientY;
					toolbar.style.display = 'none';
					textBox.style.display = 'none'; // 隐藏文本框
					selectionHint.style.display = 'none';

					// 初始化选区矩形
					updateSelectionBoxVisual({ left: startX, top: startY, width: 0, height: 0 });
					selectionBox.style.display = 'block';

					// 清除之前的绘制和文本
					textElements = [];
					drawElements = [];
					drawCtx.clearRect(0, 0, drawCanvas.width, drawCanvas.height);
					drawCanvas.style.display = 'none';
					return;
				}
				if (!lastRect || !isPointInSelection(e.clientX, e.clientY)) {
					return;
				}
				if (currentMode === 'rect' || currentMode === 'arrow') {
					console.log('鼠标按下 - 图形模式', currentMode);
					drawing = true;
					startX = e.clientX;
					startY = e.clientY;
					currentPathPoints = [];
				} else if (currentMode === 'brush') {
					console.log('鼠标按下 - 画笔模式');
					drawing = true;
					startX = e.clientX;
					startY = e.clientY;
					currentPathPoints = [{ x: e.clientX, y: e.clientY }];
					redrawDrawCanvas();
					drawPathOnCanvas(drawCtx, currentPathPoints, currentAnnotateColor, currentLineWidth, lastRect.left, lastRect.top);
				} else if (currentMode === 'erase') {
					console.log('鼠标按下 - 橡皮擦模式');
					finishTextInput();
					drawing = true;
					eraseAtPoint(e.clientX, e.clientY);
				} else if (currentMode === 'text') {
					console.log('鼠标按下 - 文本模式', { textInputActive, lastRect });
					if (textInputActive) {
						const textBoxRect = textBox.getBoundingClientRect();
						const clickedOnTextBox = e.clientX >= textBoxRect.left && e.clientX <= textBoxRect.right &&
							e.clientY >= textBoxRect.top && e.clientY <= textBoxRect.bottom;
						if (clickedOnTextBox) {
							e.preventDefault();
							e.stopPropagation();
							return;
						}
						finishTextInput();
					}
					openTextInputAt(e.clientX, e.clientY);
					drawCanvas.style.pointerEvents = 'auto';
					e.preventDefault();
					e.stopPropagation();
				}
			};

			const onMouseMove = (e) => {
				if (currentMode === 'select' && isDown) {
					const currentX = e.clientX;
					const currentY = e.clientY;
					const width = Math.abs(currentX - startX);
					const height = Math.abs(currentY - startY);

					const left = Math.min(currentX, startX);
					const top = Math.min(currentY, startY);
					updateSelectionBoxVisual({ left, top, width, height });
				} else if (currentMode === 'rect' && drawing && lastRect) {
					const currentX = e.clientX;
					const currentY = e.clientY;
					const rectX = Math.min(startX, currentX);
					const rectY = Math.min(startY, currentY);
					const rectWidth = Math.abs(currentX - startX);
					const rectHeight = Math.abs(currentY - startY);

					drawCtx.clearRect(0, 0, drawCanvas.width, drawCanvas.height);
					redrawDrawCanvas();

					drawCtx.strokeStyle = currentAnnotateColor;
					drawCtx.lineWidth = currentLineWidth;
					drawCtx.lineJoin = 'round';
					drawCtx.strokeRect(rectX - lastRect.left, rectY - lastRect.top, rectWidth, rectHeight);
				} else if (currentMode === 'arrow' && drawing && lastRect) {
					redrawDrawCanvas();
					drawArrowOnCanvas(drawCtx, {
						startX,
						startY,
						endX: e.clientX,
						endY: e.clientY,
						color: currentAnnotateColor,
						lineWidth: currentLineWidth
					}, lastRect.left, lastRect.top);
				} else if (currentMode === 'brush' && drawing && lastRect) {
					currentPathPoints.push({ x: e.clientX, y: e.clientY });
					redrawDrawCanvas();
					drawPathOnCanvas(drawCtx, currentPathPoints, currentAnnotateColor, currentLineWidth, lastRect.left, lastRect.top);
				} else if (currentMode === 'erase' && drawing && lastRect) {
					eraseAtPoint(e.clientX, e.clientY);
				}
			};

			const onMouseUp = (e) => {
				if (currentMode === 'select' && isDown) {
					isDown = false;
					const endX = e.clientX;
					const endY = e.clientY;
					const left = Math.min(startX, endX);
					const top = Math.min(startY, endY);
					const width = Math.abs(endX - startX);
					const height = Math.abs(endY - startY);

					if (width < 10 || height < 10) {
						console.log('选择区域太小，取消');
						cleanup();
						return;
					}

					lastRect = { left, top, width, height };
					updateSelectionBoxVisual(lastRect);
					console.log('选择完成:', lastRect);

					// 设置drawCanvas的位置和大小
					drawCanvas.style.left = `${left}px`;
					drawCanvas.style.top = `${top}px`;
					drawCanvas.width = width;
					drawCanvas.height = height;
					drawCanvas.style.display = 'block';
					drawCanvas.style.pointerEvents = 'none'; // 默认不响应鼠标事件

					toolbar.style.display = 'flex';
					inlineColorBar.style.display = 'none';
					inlineWidthBar.style.display = 'none';
					alignToolbarToSelectionRight();
					// 默认不设置激活状态，让用户自己选择模式
				} else if (currentMode === 'rect' && drawing && lastRect) {
					drawing = false;
					const endX = e.clientX;
					const endY = e.clientY;
					const rectX = Math.min(startX, endX);
					const rectY = Math.min(startY, endY);
					const rectWidth = Math.abs(endX - startX);
					const rectHeight = Math.abs(endY - startY);

					if (rectWidth > 0 && rectHeight > 0) {
						drawElements.push({
							type: 'rect',
							x: rectX,
							y: rectY,
							width: rectWidth,
							height: rectHeight,
							color: currentAnnotateColor,
							lineWidth: currentLineWidth
						});
						redrawDrawCanvas(); // 绘制所有保存的元素
					}
					drawCanvas.style.pointerEvents = 'none'; // 绘制完成后禁用鼠标事件
				} else if (currentMode === 'arrow' && drawing && lastRect) {
					drawing = false;
					if (Math.hypot(e.clientX - startX, e.clientY - startY) > 4) {
						drawElements.push({
							type: 'arrow',
							startX,
							startY,
							endX: e.clientX,
							endY: e.clientY,
							color: currentAnnotateColor,
							lineWidth: currentLineWidth
						});
						redrawDrawCanvas();
					}
					currentPathPoints = [];
				} else if (currentMode === 'brush' && drawing && lastRect) {
					drawing = false;
					if (currentPathPoints.length) {
						drawElements.push({
							type: 'brush',
							points: currentPathPoints.slice(),
							color: currentAnnotateColor,
							lineWidth: currentLineWidth
						});
						currentPathPoints = [];
						redrawDrawCanvas();
					}
				} else if (currentMode === 'erase' && drawing) {
					drawing = false;
					currentPathPoints = [];
				}
			};

			const onDoubleClick = (e) => {
				console.log('双击取消截图');
				cleanup();
			};

			const finishTextInput = () => {
				if (textInputActive && textBox.value.trim() !== '') {
					textElements.push({
						x: parseInt(textBox.dataset.startX),
						y: parseInt(textBox.dataset.startY),
						text: textBox.value,
						color: currentAnnotateColor, // 使用当前选择的颜色
						font: getAnnotationFont()
					});
					redrawDrawCanvas();
				}
				textBox.style.display = 'none';
				textBox.value = '';
				textInputActive = false;
				drawCanvas.style.pointerEvents = 'none'; // 文本输入完成后禁用鼠标事件
			};

			const handleKeyDown = (e) => {
				if (e.key === 'Escape') {
					if (textInputActive) {
						// 如果文本框激活，按ESC取消文本输入
						textBox.style.display = 'none';
						textBox.value = '';
						textInputActive = false;
						drawCanvas.style.pointerEvents = 'none';
					} else {
						// 否则取消整个截图
						cleanup();
					}
				} else if (e.key === 'Enter' && textInputActive && !e.shiftKey) {
					// 按Enter完成文本输入，Shift+Enter换行
					e.preventDefault();
					finishTextInput();
				}
			};

			// 添加按钮（白色图标按钮）
			const createButton = (text, onClick, className = '', title = '') => {
				const btn = document.createElement('button');
				btn.innerHTML = text;
				btn.type = 'button';
				btn.title = title;
				btn.style.margin = '0';
				btn.style.padding = '0';
				btn.style.border = 'none';
				btn.style.borderRadius = '10px';
				btn.style.background = 'transparent';
				btn.style.color = '#334155';
				btn.style.cursor = 'pointer';
				btn.style.fontSize = '17px';
				btn.style.fontWeight = '600';
				btn.style.lineHeight = '1';
				btn.style.width = '34px';
				btn.style.height = '34px';
				btn.style.display = 'flex';
				btn.style.alignItems = 'center';
				btn.style.justifyContent = 'center';
				btn.style.transition = 'background-color 0.15s ease, color 0.15s ease, transform 0.15s ease';
				btn.classList.add('screenshot-toolbar-btn');
				if (className) btn.classList.add(className);
				btn.addEventListener('mouseenter', () => {
					if (!btn.classList.contains('active')) {
						btn.style.background = 'rgba(15, 23, 42, 0.06)';
					}
				});
				btn.addEventListener('mouseleave', () => {
					if (!btn.classList.contains('active')) {
						btn.style.background = 'transparent';
					}
				});

				btn.addEventListener('click', (e) => {
					if (e) {
						e.preventDefault();
						e.stopPropagation();
					}
					btn.style.transform = 'scale(0.96)';
					setTimeout(() => {
						btn.style.transform = 'scale(1)';
					}, 90);
					onClick();
				});
				return btn;
			};

		const alignToolbarToSelectionRight = () => {
			if (!lastRect || toolbar.style.display === 'none') {
				return;
			}
			toolbar.style.visibility = 'hidden';
			const toolbarWidth = toolbar.offsetWidth;
			const toolbarHeight = toolbar.offsetHeight;
			const toolbarX = Math.max(10, Math.min(window.innerWidth - toolbarWidth - 10, lastRect.left + lastRect.width - toolbarWidth));
			const belowSelectionY = lastRect.top + lastRect.height + 8;
			const aboveSelectionY = lastRect.top - toolbarHeight - 8;
			const toolbarY = belowSelectionY + toolbarHeight + 10 <= window.innerHeight
				? belowSelectionY
				: Math.max(10, aboveSelectionY);
			toolbar.style.left = `${toolbarX}px`;
			toolbar.style.top = `${toolbarY}px`;
			toolbar.style.visibility = 'visible';
		};

		const setActiveMode = (mode, button) => {
			currentMode = mode;
			document.querySelectorAll('.screenshot-toolbar-btn').forEach(btn => {
				btn.classList.remove('active');
				btn.style.background = 'transparent';
				btn.style.color = '#334155';
			});
			button.classList.add('active');
			button.style.background = '#dbeafe';
			button.style.color = '#1d4ed8';
			const showStyledToolbar = ['rect', 'arrow', 'brush', 'text'].includes(mode);
			inlineWidthBar.style.display = showStyledToolbar ? 'inline-flex' : 'none';
			inlineColorBar.style.display = showStyledToolbar ? 'inline-flex' : 'none';
			alignToolbarToSelectionRight();
			overlay.style.cursor = mode === 'text' ? 'text' : 'crosshair';
			
			// 切换模式时重置drawCanvas的事件穿透，确保overlay能接收事件
			// 只有在绘制模式下，且正在绘制时才需要auto，这里统一重置为none，由onMouseDown动态控制
			if (drawCanvas) {
				drawCanvas.style.pointerEvents = 'none';
			}
			
			finishTextInput(); // 切换模式时完成当前文本输入
		};

		const inlineWidthBar = document.createElement('div');
		inlineWidthBar.style.display = 'none';
		inlineWidthBar.style.alignItems = 'center';
		inlineWidthBar.style.gap = '4px';
		inlineWidthBar.style.marginRight = '6px';
		inlineWidthBar.style.paddingRight = '6px';
		inlineWidthBar.style.borderRight = '1px solid rgba(148, 163, 184, 0.24)';

		const widthOptions = [2, 4, 6, 8];
		const widthButtons = [];
		const syncLineWidth = (lineWidth) => {
			currentLineWidth = lineWidth;
			widthButtons.forEach(btn => {
				const isActive = Number(btn.dataset.lineWidth) === lineWidth;
				btn.style.background = isActive ? '#dbeafe' : 'transparent';
				btn.style.boxShadow = isActive ? '0 0 0 1px rgba(29, 78, 216, 0.10)' : 'none';
			});
			if (textInputActive) {
				textBox.style.fontSize = `${getAnnotationFontSize()}px`;
				textBox.style.lineHeight = `${Math.round(getAnnotationFontSize() * 1.2)}px`;
				textBox.style.minHeight = `${Math.round(getAnnotationFontSize() * 1.4)}px`;
				textBox.style.color = currentAnnotateColor;
			}
		};
		widthOptions.forEach((lineWidth) => {
			const widthBtn = document.createElement('button');
			widthBtn.dataset.lineWidth = lineWidth;
			widthBtn.type = 'button';
			widthBtn.title = `${lineWidth}px`;
			widthBtn.style.width = '26px';
			widthBtn.style.height = '26px';
			widthBtn.style.padding = '0';
			widthBtn.style.margin = '0';
			widthBtn.style.border = 'none';
			widthBtn.style.borderRadius = '7px';
			widthBtn.style.background = 'transparent';
			widthBtn.style.cursor = 'pointer';
			widthBtn.style.display = 'flex';
			widthBtn.style.alignItems = 'center';
			widthBtn.style.justifyContent = 'center';
			widthBtn.style.transition = 'background-color 0.15s ease, box-shadow 0.15s ease';
			const widthLine = document.createElement('span');
			widthLine.style.display = 'block';
			widthLine.style.width = '16px';
			widthLine.style.height = `${lineWidth}px`;
			widthLine.style.borderRadius = '999px';
			widthLine.style.background = '#111827';
			widthBtn.appendChild(widthLine);
			widthBtn.addEventListener('click', (e) => {
				e.preventDefault();
				e.stopPropagation();
				syncLineWidth(lineWidth);
			});
			widthButtons.push(widthBtn);
			inlineWidthBar.appendChild(widthBtn);
		});
		syncLineWidth(currentLineWidth);

		const inlineColorBar = document.createElement('div');
		inlineColorBar.style.display = 'none';
		inlineColorBar.style.alignItems = 'center';
		inlineColorBar.style.gap = '5px';
		inlineColorBar.style.marginRight = '6px';
		inlineColorBar.style.paddingRight = '6px';
		inlineColorBar.style.borderRight = '1px solid rgba(148, 163, 184, 0.24)';
		const colors = [
			{ value: '#FF3B30' },
			{ value: '#FFCC00' },
			{ value: '#1677FF' },
			{ value: '#34C759' },
			{ value: '#000000' }
		];
		const colorButtons = [];
		const syncAnnotateColor = (colorValue) => {
			currentAnnotateColor = colorValue;
			colorButtons.forEach(btn => {
				const isActive = btn.dataset.color === colorValue;
				btn.style.transform = isActive ? 'scale(1.08)' : 'scale(1)';
				btn.style.boxShadow = isActive
					? '0 0 0 2px rgba(255, 255, 255, 0.92), 0 0 0 3px rgba(17, 24, 39, 0.14)'
					: '0 0 0 1px rgba(17, 24, 39, 0.1)';
			});
			if (textInputActive) {
				textBox.style.color = currentAnnotateColor;
			}
		};
		colors.forEach((color) => {
			const colorBtn = document.createElement('button');
			colorBtn.dataset.color = color.value;
			colorBtn.type = 'button';
			colorBtn.title = '颜色';
			colorBtn.style.width = '16px';
			colorBtn.style.height = '16px';
			colorBtn.style.padding = '0';
			colorBtn.style.margin = '0';
			colorBtn.style.border = 'none';
			colorBtn.style.borderRadius = '50%';
			colorBtn.style.background = color.value;
			colorBtn.style.cursor = 'pointer';
			colorBtn.style.transition = 'transform 0.15s ease, box-shadow 0.15s ease';
			colorBtn.addEventListener('click', (e) => {
				e.preventDefault();
				e.stopPropagation();
				syncAnnotateColor(color.value);
			});
			colorButtons.push(colorBtn);
			inlineColorBar.appendChild(colorBtn);
		});
		syncAnnotateColor(currentAnnotateColor);

		const openPinnedPreview = () => {
			self.$message.warning('当前 Web 版无法实现系统级桌面置顶，只能在桌面端容器里支持');
		};

		const rectWithEllipseIcon = `
			<svg width="18" height="18" viewBox="0 0 18 18" aria-hidden="true">
				<rect x="2" y="2" width="8.5" height="8.5" rx="1.2" fill="none" stroke="currentColor" stroke-width="1.5"></rect>
				<ellipse cx="12.2" cy="12.2" rx="3.9" ry="2.7" fill="none" stroke="currentColor" stroke-width="1.5"></ellipse>
			</svg>
		`;
		const arrowIcon = `
			<svg width="18" height="18" viewBox="0 0 18 18" aria-hidden="true">
				<path d="M3 13 L13 5" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"></path>
				<path d="M10.6 4.7 L13.7 4.7 L13.7 7.8" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"></path>
			</svg>
		`;
		const brushIcon = `
			<svg width="18" height="18" viewBox="0 0 18 18" aria-hidden="true">
				<path d="M11.8 3.2 L14.8 6.2 L8.1 12.9 L4.8 13.2 L5.1 9.9 Z" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"></path>
				<path d="M4.6 13.1 C4.4 14.3 3.4 15 2 15" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"></path>
			</svg>
		`;
		const eraserIcon = `
			<svg width="18" height="18" viewBox="0 0 18 18" aria-hidden="true">
				<path d="M6 4.2 L13.8 12 L10.6 15.2 L2.8 7.4 Z" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"></path>
				<path d="M10.6 15.2 H15.4" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"></path>
			</svg>
		`;

		// 工具条按钮：线宽 / 颜色 / 矩形 / 箭头 / 画笔 / A / 钉 / ❎ / ✅
		const rectBtn = createButton(rectWithEllipseIcon, () => {
			console.log('点击了工具条-矩形');
			setActiveMode('rect', rectBtn);
		}, 'rect-btn', '矩形/椭圆框');
		const arrowBtn = createButton(arrowIcon, () => {
			console.log('点击了工具条-箭头');
			setActiveMode('arrow', arrowBtn);
		}, 'arrow-btn', '箭头');
		const brushBtn = createButton(brushIcon, () => {
			console.log('点击了工具条-画笔');
			setActiveMode('brush', brushBtn);
		}, 'brush-btn', '画笔');
		const eraserBtn = createButton(eraserIcon, () => {
			console.log('点击了工具条-橡皮擦');
			setActiveMode('erase', eraserBtn);
		}, 'eraser-btn', '橡皮擦');
		const textBtn = createButton('A', () => {
			console.log('点击了工具条-文字');
			setActiveMode('text', textBtn);
		}, 'text-btn', '文字');

		const pinBtn = createButton('钉', () => {
			console.log('点击了工具条-钉');
			inlineWidthBar.style.display = 'none';
			inlineColorBar.style.display = 'none';
			alignToolbarToSelectionRight();
			openPinnedPreview();
		}, 'pin-btn', '钉住');
		pinBtn.style.fontSize = '14px';
		pinBtn.style.width = 'auto';
		pinBtn.style.height = '34px';
		pinBtn.style.padding = '0 10px';
		pinBtn.style.borderRadius = '10px';

		const cancelBtn = createButton('✕', () => {
			console.log('点击了取消按钮');
			cleanup();
		}, 'cancel-btn', '取消');
		const okBtn = createButton('✓', () => {
			console.log('确定按钮被点击');
			if (!lastRect) {
				self.$message.warning('请先选择截图区域');
				cleanup();
				return;
			}
			inlineWidthBar.style.display = 'none';
			inlineColorBar.style.display = 'none';
			captureAndProcessScreenshot(true);
		}, 'ok-btn', '完成并复制');
		okBtn.style.color = '#0f766e';

		const toolbarDivider = document.createElement('span');
		toolbarDivider.style.width = '1px';
		toolbarDivider.style.height = '24px';
		toolbarDivider.style.margin = '0 2px';
		toolbarDivider.style.background = 'rgba(148, 163, 184, 0.28)';

		toolbar.appendChild(inlineWidthBar);
		toolbar.appendChild(inlineColorBar);
		toolbar.appendChild(rectBtn);
		toolbar.appendChild(arrowBtn);
		toolbar.appendChild(brushBtn);
		toolbar.appendChild(eraserBtn);
		toolbar.appendChild(textBtn);
		toolbar.appendChild(pinBtn);
		toolbar.appendChild(toolbarDivider);
		toolbar.appendChild(cancelBtn);
		toolbar.appendChild(okBtn);

			// 辅助函数：捕获并处理截图
			const captureAndProcessScreenshot = (copyToClipboard = false) => {
				if (!lastRect) {
					cleanup();
					return;
				}

				finishTextInput(); // 确保所有文本都已保存

				const { left, top, width, height } = lastRect;

				// 截图前先隐藏遮罩、选区和工具条，避免这些UI出现在截图中
				if (overlay) overlay.style.display = 'none';
				if (selectionBox) selectionBox.style.display = 'none';
				if (toolbar) toolbar.style.display = 'none';
				if (drawCanvas) drawCanvas.style.display = 'none'; // 隐藏绘制层

				console.log('开始截图...');
				html2canvas(document.body, {
					useCORS: true,
					backgroundColor: '#ffffff',
					logging: false, // 减少控制台输出
					// 确保截图包含所有可见内容，包括绘制层
					ignoreElements: (element) => {
						return element === overlay || element === selectionBox || element === toolbar || element === textBox;
					}
				}).then(canvas => {
					try {
						const ratioX = canvas.width / window.innerWidth;
						const ratioY = canvas.height / window.innerHeight;
						const cropLeft = left * ratioX;
						const cropTop = top * ratioY;
						const cropWidth = width * ratioX;
						const cropHeight = height * ratioY;

						const croppedCanvas = document.createElement('canvas');
						croppedCanvas.width = cropWidth;
						croppedCanvas.height = cropHeight;

						const ctx = croppedCanvas.getContext('2d');
						ctx.drawImage(canvas, cropLeft, cropTop, cropWidth, cropHeight, 0, 0, cropWidth, cropHeight);

						// 将drawCanvas上的内容绘制到croppedCanvas上
						// drawCanvas的内容是相对于lastRect的，所以直接绘制即可
						if (drawCanvas.width > 0 && drawCanvas.height > 0) {
							ctx.drawImage(drawCanvas, 0, 0, cropWidth, cropHeight);
						}

						const dataUrl = croppedCanvas.toDataURL('image/png');
						console.log('截图成功，大小:', (dataUrl.length / 1024).toFixed(2) + 'KB');

						if (!copyToClipboard) {
							cleanup();
							return;
						}
						// 复制到剪贴板
						croppedCanvas.toBlob(blob => {
							// eslint-disable-next-line no-undef
							const item = new ClipboardItem({ "image/png": blob });
							navigator.clipboard.write([item]).then(() => {
								self.$message.success('截图已复制到剪贴板');
								cleanup();
							}).catch(err => {
								console.error('复制到剪贴板失败:', err);
								self.$message.error('复制到剪贴板失败: ' + (err.message || '未知错误'));
								cleanup();
							});
						}, 'image/png');
					} catch (err) {
						console.error('截图处理失败:', err);
						self.$message.error('截图处理失败: ' + (err.message || '未知错误'));
						cleanup();
					}
				}).catch(err => {
					console.error('截图捕获失败:', err);
					self.$message.error('截图捕获失败: ' + (err.message || '未知错误'));
					cleanup();
				});
			};

		// 记录文本框创建时间,防止点击创建时立即触发关闭
		let lastTextBoxCreateTime = 0;

		// 点击其他地方也取消(仅在已经有选区时才生效,避免刚进入截图模式就被取消)
		const handleDocumentClick = (e) => {
			// 还没产生选区(lastRect 为空)时,不处理"点外面取消",否则会把刚进入的截图模式直接清掉
			if (!lastRect) {
				return;
			}

			// 如果点击了工具条、文本框或颜色选择器内部,不取消
			if (toolbar.contains(e.target) || textBox.contains(e.target)) {
				return;
			}

			// 如果刚创建文本框(500ms内),忽略点击事件
			if (Date.now() - lastTextBoxCreateTime < 500) {
				return;
			}

			// 如果文本框激活,点击其他地方完成文本输入
			if (textInputActive) {
				finishTextInput();
				return;
			}

			// 如果点击了遮罩层但不是在选区内,且不是在工具条或文本框内,则取消
			if (e.target === overlay) {
				const { clientX, clientY } = e;
				if (lastRect && (clientX < lastRect.left || clientX > lastRect.left + lastRect.width ||
					clientY < lastRect.top || clientY > lastRect.top + lastRect.height)) {
					console.log('点击了遮罩层选区外部,取消截图');
					cleanup();
				}
			}
		};

			// 阻止右键菜单
			const preventContextMenu = (e) => {
				e.preventDefault();
				return false;
			};

			// 处理overlay上的点击事件,防止冒泡到document导致文本框关闭
			const onOverlayClick = (e) => {
				if (currentMode === 'text' && lastRect) {
					const relX = e.clientX - lastRect.left;
					const relY = e.clientY - lastRect.top;
					
					// 如果点击在选区内,阻止冒泡
					if (relX >= 0 && relX <= lastRect.width && relY >= 0 && relY <= lastRect.height) {
						e.stopPropagation();
					}
				}
			};

			// 绑定事件
			overlay.addEventListener('mousedown', onMouseDown);
			overlay.addEventListener('mousemove', onMouseMove);
			overlay.addEventListener('mouseup', onMouseUp);
			overlay.addEventListener('click', onOverlayClick); // 添加点击事件处理
			overlay.addEventListener('dblclick', onDoubleClick);
			overlay.addEventListener('contextmenu', preventContextMenu);
			document.addEventListener('click', handleDocumentClick);
			document.addEventListener('keydown', handleKeyDown);

			console.log('截图模式已启动');
		},

		closeForwardSelect() {
			this.showForwardSelect = false;
			this.forwardMsg = {};
			this.forwardBatch = null;
		}
	},
	computed: {
		canSendMessage() {
			if (this.quoteMessage && this.isInputEmpty) {
				return false;
			}
			return true;
		},
		resourceTabs() {
			return [
				{ type: 'history', label: '聊天记录' },
				{ type: 'media', label: '文件-图片-视频' },
				{ type: 'link', label: '链接' },
				{ type: 'location', label: '位置' }
			];
		},
		activeResourceLabel() {
			const tab = this.resourceTabs.find(item => item.type === this.activeResourceType);
			return tab ? tab.label : '聊天记录';
		},
		filteredResourceMessages() {
			return this.getResourceMessages().filter(item => this.matchesResourceSearch(item));
		},
		mine() {
			return this.userStore.userInfo;
		},
		isFriend() {
			return this.friendStore.isFriend(this.userInfo.id);
		},
		friend() {
			return this.friendStore.findFriend(this.userInfo.id)
		},
		title() {
			let title = this.chat.showName;
			if (this.chat.type == "GROUP") {
				let size = this.groupMembers.filter(m => !m.quit).length;
				title += `(${size})`;
			}
			return title;
		},
		messageAction() {
			return `/message/${this.chat.type.toLowerCase()}/send`;
		},
		unreadCount() {
			return this.chat.unreadCount;
		},
		showMessages() {
			console.log("this.chat.messages.slice(this.showMinIdx):",this.chat.messages.slice(this.showMinIdx))
			return this.chat.messages.slice(this.showMinIdx)
		},
		messageSize() {
			if (!this.chat || !this.chat.messages) {
				return 0;
			}
			return this.chat.messages.length;
		},
		isBanned() {
			return (this.chat.type == "PRIVATE" && this.userInfo.isBanned) ||
				(this.chat.type == "GROUP" && this.group.isBanned)
		},
		memberSize() {
			return this.groupMembers.filter(m => !m.quit).length;
		},
		isGroup() {
			return this.chat.type == 'GROUP';
		},
		isPrivate() {
			return this.chat.type == 'PRIVATE';
		}
	},
	watch: {
		showForwardSelect(newVal) {
			// 转发对话框状态变化
		},
		chat: {
			handler(newChat, oldChat) {
				if (newChat.targetId > 0 && (!oldChat || newChat.type != oldChat.type ||
					newChat.targetId != oldChat.targetId)) {
					this.userInfo = {}
					this.group = {};
					this.groupMembers = [];
					if (this.chat.type == "GROUP") {
						this.loadGroup(this.chat.targetId);
					} else {
						this.loadFriend(this.chat.targetId);
						// 加载已读状态
						this.loadReaded(this.chat.targetId)
					}
					// 滚到底部
					this.scrollToBottom();
					this.showSide = false;
					// 消息已读
					this.readedMessage()
					// 初始状态只显示30条消息
					let size = this.chat.messages.length;
					this.showMinIdx = size > 30 ? size - 30 : 0;
					// 重置输入框
					this.resetEditor();
					// 复位回执消息
					this.isReceipt = false;
					this.showResourcePanel = false;
					this.resourceSearchText = '';
					this.activeResourceType = 'history';
					// 更新placeholder
					this.refreshPlaceHolder();
				}
			},
			immediate: true
		},
		messageSize: {
			handler(newSize, oldSize) {
				if (newSize > oldSize) {
					if (this.isInBottom) {
						// 拉至底部
						this.scrollToBottom();
					} else {
						// 增加新消息提醒
						this.newMessageSize++;
					}
				}
			}
		}
	},
	mounted() {
		let div = document.getElementById("chatScrollBox");
		div.addEventListener('scroll', this.onScroll)
		window.addEventListener('online', this.retryPendingTextMessages);
	},
	beforeDestroy() {
		if (this.callStartController) {
			this.callStartController.cancel();
			this.callStartController = null;
		}
		if (this.callStartCloseTimer) {
			clearTimeout(this.callStartCloseTimer);
			this.callStartCloseTimer = null;
		}
		this.cancelResourceLongPress();
		window.removeEventListener('online', this.retryPendingTextMessages);
		Object.keys(this.pendingTextSends).forEach((clientMsgId) => {
			const task = this.pendingTextSends[clientMsgId];
			if (task && !task.completed) {
				task.expired = true;
				this.clearTextSendTimers(task);
				this.setTextSendState(task, 'fail', 'fail');
			}
		});
	}
}
</script>

<style lang="scss" scoped>
.chat-box {
	position: relative;
	width: 100%;
	height: 100%;
	background: #fff;
	overflow: hidden;  /* 防止内容溢出 */

	.el-header {
		display: flex;
		align-items: center;
		padding: 0 12px;
		line-height: 50px;
		font-size: var(--im-font-size-larger);
		border-bottom: var(--im-border);

		.chat-title {
			flex: 0 1 auto;
			min-width: 0;
			max-width: 42%;
			overflow: hidden;
			text-overflow: ellipsis;
			white-space: nowrap;
			line-height: 50px;
		}

		.chat-resource-tabs {
			display: flex;
			align-items: center;
			gap: 4px;
			height: 50px;
			margin-left: auto;
			margin-right: 10px;
		}

		.chat-resource-tab {
			height: 28px;
			padding: 0 10px;
			border: 1px solid transparent;
			border-radius: 4px;
			background: transparent;
			color: #606266;
			font-size: 14px;
			line-height: 26px;
			white-space: nowrap;
			cursor: pointer;
			transition: background-color 0.15s ease, color 0.15s ease, border-color 0.15s ease;
		}

		.chat-resource-tab:hover {
			background: #eef3ff;
			color: #2f5caa;
		}

		.chat-resource-tab.active {
			background: #d4def5;
			border-color: #c3cfef;
			color: #111827;
			font-weight: 600;
		}


		.btn-side {
			flex: 0 0 32px;
			display: inline-flex;
			align-items: center;
			justify-content: center;
			height: 50px;
			line-height: 50px;
			font-size: 20px;
			cursor: pointer;
			color: var(--im-text-color-light);
		}
	}

	.content-box {
		position: relative;

		.im-chat-main {
			padding: 0 16px;  /* 添加左右内边距 */
			background-color: #f5f7fa;  /* 使用浅灰色背景 */
			box-sizing: border-box;  /* 确保内边距不会影响元素宽度 */
			height: 100%;  /* 确保背景色填充整个区域 */

			.im-chat-box {
				>div {
					margin-bottom: 10px;
				}
			}
		}

		.scroll-to-bottom {
			text-align: right;
			position: absolute;
			right: 20px;
			bottom: 230px;
			color: #000; /* 文字改为黑色 */
			font-size: var(--im-font-size);
			font-weight: 600;
			background: #eee;
			padding: 5px 15px;
			border-radius: 15px;
			cursor: pointer;
			z-index: 99;
			box-shadow: var(--im-box-shadow-light);
		}

		.im-chat-footer {
			display: flex;
			flex-direction: column;
			padding: 0;
			background-color: #f5f7fa; /* 新增背景色 */

			.multi-select-bar {
				display: flex;
				align-items: center;
				justify-content: space-between;
				height: 42px;
				padding: 0 8px 0 16px;
				border-top: var(--im-border);
				background: #ffffff;
				box-sizing: border-box;
			}

			.multi-select-count {
				font-size: 13px;
				color: #606266;
			}

			.multi-select-actions {
				display: flex;
				align-items: center;
				gap: 8px;
			}

			.multi-select-actions .el-button {
				margin-left: 0;
			}

			.batch-forward-wrapper {
				position: relative;
				display: inline-flex;
			}

			.batch-forward-menu {
				position: absolute;
				right: 0;
				bottom: 34px;
				min-width: 104px;
				padding: 6px 0;
				background: #ffffff;
				border: 1px solid #ebeef5;
				border-radius: 4px;
				box-shadow: 0 2px 12px rgba(0, 0, 0, 0.12);
				z-index: 20;
			}

			.batch-forward-menu-item {
				padding: 8px 14px;
				font-size: 13px;
				line-height: 18px;
				color: #303133;
				white-space: nowrap;
				cursor: pointer;
			}

			.batch-forward-menu-item:hover {
				background: #f5f7fa;
				color: #409eff;
			}

			.chat-tool-bar {
				display: flex;
				position: relative;
				width: 100%;
				height: 36px;
				text-align: left;
				box-sizing: border-box;
				border-top: var(--im-border);
				padding: 4px 2px 2px 8px;
				color: #9ca3af; /* 默认浅灰色图标 */

				>div {
					font-size: 22px;
					cursor: pointer;
					line-height: 30px;
					width: 30px;
					height: 30px;
					text-align: center;
					border-radius: 2px;
					margin-right: 4px; /* 控制每个图标块之间的统一间距，略微紧凑 */
				}
				
				>div:hover {
					color: #4b5563; /* hover：深一点的黑色 */
				}
				
				/* 选中态：例如“回执消息”按钮被点亮时变为蓝色 */
				.chat-tool-active {
					color: #1a73e8 !important;
				}

				/* 上传按钮（图片/文件）统一继承文字颜色，清除全局绿色主题 */
				.el-upload,
				.el-upload * {
					background-color: transparent !important;
					border-color: transparent !important;
					box-shadow: none !important;
					color: inherit !important; /* 完全继承工具栏的颜色：默认浅灰，hover 深色，选中蓝色 */
				}
			}

			.send-content-area {
				display: flex;
				flex-direction: column;
				height: 100%;
				background-color: #f5f7fa;
			}

				/* 发送按钮区域：靠右对齐，固定在输入区下方 */
			.send-btn-area {
				padding: 10px;
				display: flex;
				justify-content: flex-end;
				align-items: center;
				margin-top: auto;   /* 使用 auto 顶下去，使按钮区域始终贴在底部 */
								.el-button--primary {
						background-color: #d4def5;  /* Web 主色：与聊天选中气泡/顶部条同一色系的浅蓝 */
						border-color: #d4def5;
						color: #111827;
						box-shadow: none;
					}
					
					.el-button--primary:hover,
					.el-button--primary:focus {
						background-color: #c3cfef;
						border-color: #c3cfef;
						color: #111827;
					}

					.send-btn-disabled.el-button--primary.is-disabled,
					.send-btn-disabled.el-button--primary.is-disabled:hover,
					.send-btn-disabled.el-button--primary.is-disabled:focus,
					.send-btn-disabled.el-button--primary.is-disabled:active {
						background-color: #e5e7eb;
						border-color: #e5e7eb;
						color: #9ca3af;
						cursor: not-allowed;
					}
				
				/* 发送模式切换三角：仅旋转图标，其他样式不动 */
				.send-mode-toggle {
					display: inline-flex;
					align-items: center;
					justify-content: center;
					margin-left: 4px;
					cursor: pointer;
				}

				.send-mode-disabled {
					pointer-events: none;
				}

				.send-mode-toggle.is-disabled {
					color: #9ca3af;
					cursor: not-allowed;
					opacity: 0.8;
				}
				
				.send-mode-toggle .el-icon-arrow-up {
					transform: rotate(90deg); /* 向右旋转 90° */
				}
			}

			.chat-quote-bar {
				display: flex;
				align-items: center;
				gap: 6px;
				align-self: flex-start;
				width: 290px;
				max-width: calc(100% - 24px);
				min-height: 30px;
				margin: 3px 12px 0;
				padding: 3px 8px;
				box-sizing: border-box;
				border-radius: 4px;
				background: #eceff3;
			}

			.chat-quote-bar.quote-bar-two-line {
				height: 60px;
				min-height: 60px;
			}

			.chat-quote-bar .quote-pill {
				display: flex;
				align-items: center;
				flex: 1 1 auto;
				min-width: 0;
				max-width: 100%;
				min-height: 24px;
				box-sizing: border-box;
				padding: 0 2px;
				border-radius: 0;
				background: transparent;
				color: #4b5563;
				box-shadow: none;
			}

			.chat-quote-bar .quote-pill:not(.quote-pill-rich) .quote-name,
			.chat-quote-bar .quote-pill:not(.quote-pill-rich) .quote-text {
				font-size: 12px;
				line-height: 18px;
			}

			.chat-quote-bar .quote-pill-rich {
				gap: 8px;
				align-items: center;
			}

			.chat-quote-bar .quote-pill-two-line {
				height: 54px;
				min-height: 54px;
				padding: 4px 2px;
			}

			.chat-quote-bar .quote-pill-two-line:not(.quote-pill-rich) {
				flex-direction: column;
				align-items: flex-start;
				justify-content: center;
				gap: 2px;
			}

			.chat-quote-bar .quote-pill-two-line:not(.quote-pill-rich) .quote-name,
			.chat-quote-bar .quote-pill-two-line:not(.quote-pill-rich) .quote-text {
				display: block;
				max-width: 100%;
				font-size: 12px;
				line-height: 18px;
			}

			.chat-quote-bar .quote-name {
				flex: 0 0 auto;
				max-width: 110px;
				overflow: hidden;
				text-overflow: ellipsis;
				white-space: nowrap;
				font-weight: 600;
				color: #4b5563;
			}

			.chat-quote-bar .quote-heading {
				display: inline-flex;
				align-items: center;
				flex: 0 1 auto;
				min-width: 0;
				margin-right: 6px;
			}

			.chat-quote-bar .quote-type-label {
				flex: 0 0 auto;
				font-size: 12px;
				font-weight: 400;
				color: #6b7280;
				white-space: nowrap;
			}

			.chat-quote-bar .quote-text {
				min-width: 0;
				overflow: hidden;
				text-overflow: ellipsis;
				white-space: nowrap;
				color: #6b7280;
			}

			.chat-quote-bar .quote-rich-main {
				min-width: 0;
				max-width: 300px;
			}

			.chat-quote-bar .quote-rich-line {
				display: flex;
				align-items: center;
				min-width: 0;
			}

			.chat-quote-bar .quote-flow-copy {
				display: block;
				width: 100%;
				max-height: 36px;
				line-height: 18px;
				overflow: hidden;
				white-space: normal;
				word-break: break-all;
			}

			.chat-quote-bar .quote-flow-prefix {
				display: inline-flex;
				align-items: center;
				max-width: 160px;
				vertical-align: bottom;
				white-space: nowrap;
			}

			.chat-quote-bar .quote-flow-body {
				font-size: 12px;
				color: #656d78;
			}

			.chat-quote-bar .quote-location-main {
				display: block;
				flex: 0 1 auto;
				min-width: 0;
			}

			.chat-quote-bar .quote-location-icon {
				margin-right: 4px;
				font-size: 16px;
				color: #737b86;
			}

			.chat-quote-bar .quote-location-text {
				color: #656d78;
			}

			.chat-quote-bar .quote-location-thumb {
				flex: 0 0 auto;
				width: 44px;
				height: 28px;
				margin-left: 8px;
				border-radius: 3px;
				object-fit: cover;
				background: #d1d5db;
			}

			.chat-quote-bar .quote-rich-icon {
				flex: 0 0 auto;
				margin-right: 4px;
				color: #6b7280;
			}

			.chat-quote-bar .quote-rich-text {
				min-width: 0;
				overflow: hidden;
				text-overflow: ellipsis;
				white-space: nowrap;
				color: #6b7280;
			}

			.chat-quote-bar .quote-card-brief {
				display: inline-flex;
				align-items: center;
				min-width: 0;
				max-width: 150px;
				color: #6b7280;
			}

			.chat-quote-bar .quote-card-type-icon {
				flex: 0 0 auto;
				margin-right: 4px;
				font-size: 16px;
				color: #6b7280;
			}

			.chat-quote-bar .quote-card-name {
				min-width: 0;
				overflow: hidden;
				text-overflow: ellipsis;
				white-space: nowrap;
			}

			.chat-quote-bar .quote-rich-thumb {
				flex: 0 0 auto;
				width: 42px;
				height: 42px;
				object-fit: cover;
				border-radius: 6px;
				background: #d1d5db;
			}

			.chat-quote-bar .quote-card-placeholder,
			.chat-quote-bar .quote-file-placeholder {
				display: inline-flex;
				align-items: center;
				justify-content: center;
				color: #fff;
				font-size: 26px;
			}

			.chat-quote-bar .quote-file-placeholder {
				color: #4b5563;
			}

			.chat-quote-bar .quote-inline-file-icon,
			.chat-quote-bar .quote-file-icon {
				position: relative;
				flex: 0 0 auto;
				display: inline-flex;
				align-items: center;
				justify-content: center;

				.file-icon-paper {
					position: relative;
					display: block;
					border-radius: 3px;
					background-color: #d42e07;
					box-shadow: 0 1px 4px rgba(15, 23, 42, 0.16);
					overflow: hidden;
				}

				.file-icon-fold {
					position: absolute;
					right: 0;
					top: 0;
					background: rgba(255, 255, 255, 0.82);
					clip-path: polygon(0 0, 100% 0, 100% 100%);
				}

				.file-icon-fold::after {
					content: "";
					position: absolute;
					left: 0;
					bottom: 0;
					height: 1px;
					background: rgba(0, 0, 0, 0.10);
					transform: rotate(45deg);
					transform-origin: left bottom;
				}

				.file-icon-mark {
					position: absolute;
					left: 0;
					right: 0;
					color: #ffffff;
					font-weight: 800;
					text-align: center;
					text-transform: uppercase;
					letter-spacing: 0;
				}

				&.file-icon-audio .file-icon-paper { background-color: #8b5cf6; }
				&.file-icon-video .file-icon-paper { background-color: #ef4444; }
				&.file-icon-word .file-icon-paper { background-color: #2b6fdb; }
				&.file-icon-excel .file-icon-paper { background-color: #1f9d55; }
				&.file-icon-ppt .file-icon-paper { background-color: #f0642f; }
				&.file-icon-pdf .file-icon-paper { background-color: #d42e07; }
				&.file-icon-image .file-icon-paper { background-color: #0ea5e9; }
				&.file-icon-archive .file-icon-paper { background-color: #a16207; }
				&.file-icon-code .file-icon-paper { background-color: #475569; }
				&.file-icon-default .file-icon-paper { background-color: #d42e07; }
			}

			.chat-quote-bar .quote-inline-file-icon {
				width: 20px;
				height: 24px;
				margin-right: 4px;

				.file-icon-paper {
					width: 16px;
					height: 20px;
				}

				.file-icon-fold {
					width: 6px;
					height: 6px;
				}

				.file-icon-fold::after {
					width: 7px;
				}

				.file-icon-mark {
					bottom: 2px;
					font-size: 10px;
					line-height: 11px;
				}

				&.file-icon-pdf .file-icon-mark,
				&.file-icon-image .file-icon-mark,
				&.file-icon-archive .file-icon-mark,
				&.file-icon-code .file-icon-mark,
				&.file-icon-default .file-icon-mark {
					font-size: 6px;
					line-height: 8px;
				}
			}

			.chat-quote-bar .quote-file-icon {
				width: 34px;
				height: 40px;

				.file-icon-paper {
					width: 28px;
					height: 35px;
				}

				.file-icon-fold {
					width: 10px;
					height: 10px;
				}

				.file-icon-fold::after {
					width: 12px;
				}

				.file-icon-mark {
					bottom: 5px;
					font-size: 18px;
					line-height: 20px;
				}

				&.file-icon-pdf .file-icon-mark,
				&.file-icon-image .file-icon-mark,
				&.file-icon-archive .file-icon-mark,
				&.file-icon-code .file-icon-mark,
				&.file-icon-default .file-icon-mark {
					font-size: 10px;
					line-height: 12px;
				}
			}

			.chat-quote-bar .quote-card-initial {
				color: #fff;
				font-size: 18px;
				font-weight: 500;
				line-height: 1;
			}

			.chat-quote-bar .quote-close {
				flex: 0 0 14px;
				width: 14px;
				height: 14px;
				padding: 0;
				border: none;
				border-radius: 50%;
				display: inline-flex;
				align-items: center;
				justify-content: center;
				background: #9ca3af;
				color: #fff;
				cursor: pointer;
				font-size: 8px;
				line-height: 1;
				transition: background-color 0.15s ease, transform 0.15s ease;
			}

			.chat-quote-bar .quote-close:hover {
				background: #6b7280;
			}

			.chat-quote-bar .quote-close:active {
				transform: scale(0.94);
			}
		}

		.icon,
		.el-icon-scissors,
		.el-icon-picture-outline,
		.el-icon-wallet,
		.el-icon-microphone,
		.el-icon-phone-outline,
		.el-icon-video-camera,
		.el-icon-chat-dot-round {
			margin: 0; /* 间距交给父级容器控制，保证一致 */
			cursor: pointer;
			color: inherit; /* 使用父元素颜色，方便 hover 控制浅/深 */
			font-size: 20px;
		}

		.friend-card-btn {
			display: inline-block;
		}

		.favorite-tool-btn {
			display: inline-flex;
			align-items: center;
			justify-content: center;
		}

		.favorite-cube-outline-icon {
			display: block;
			width: 20px;
			height: 20px;
			transform: translateY(-1px);
			fill: none;
			stroke: currentColor;
			stroke-width: 1.8;
			stroke-linecap: round;
			stroke-linejoin: round;
		}

		.icon,
		.el-icon-scissors,
		.el-icon-picture-outline,
		.el-icon-wallet,
		.el-icon-microphone,
		.el-icon-phone-outline,
		.el-icon-video-camera,
		.el-icon-chat-dot-round,
		.friend-card-btn,
		.favorite-tool-btn {
			margin: 0; /* 间距交给父级容器控制，保证一致 */
			cursor: pointer;
			color: inherit; /* 使用父元素颜色，方便 hover 控制浅/深 */
			font-size: 20px;
		}

	}

	.side-box {
		border-left: var(--im-border);
	}

	.chat-resource-side {
		border-left: var(--im-border);
		background: #ffffff;
		box-shadow: -8px 0 18px rgba(15, 23, 42, 0.05);
		overflow: hidden;
	}

	.chat-resource-panel {
		display: flex;
		flex-direction: column;
		height: 100%;
		min-height: 0;
	}

	.chat-resource-panel-header {
		display: flex;
		align-items: center;
		justify-content: space-between;
		height: 50px;
		padding: 0 14px 0 16px;
		border-bottom: var(--im-border);
		box-sizing: border-box;
		font-size: 15px;
		font-weight: 600;
		color: #1f2937;
	}

	.chat-resource-close {
		display: inline-flex;
		align-items: center;
		justify-content: center;
		width: 28px;
		height: 28px;
		padding: 0;
		border: none;
		border-radius: 50%;
		background: transparent;
		color: #909399;
		cursor: pointer;
	}

	.chat-resource-close:hover {
		background: #f1f5f9;
		color: #4b5563;
	}

	.chat-resource-search {
		padding: 12px 14px;
		border-bottom: var(--im-border);
		box-sizing: border-box;
	}

	.chat-resource-empty {
		flex: 1;
		display: flex;
		align-items: center;
		justify-content: center;
		color: #9ca3af;
		font-size: 13px;
	}

	.chat-resource-list {
		flex: 1;
		min-height: 0;
	}

	.chat-resource-row {
		display: flex;
		align-items: center;
		min-height: 70px;
		padding: 12px 14px;
		box-sizing: border-box;
		border-bottom: 1px solid #f0f2f5;
		cursor: pointer;
	}

	.chat-resource-row:hover {
		background: #f7f9fc;
	}

	.chat-resource-row-selecting {
		padding-left: 10px;
	}

	.chat-resource-select-dot {
		flex: 0 0 auto;
		display: inline-flex;
		align-items: center;
		justify-content: center;
		width: 18px;
		height: 18px;
		margin-right: 10px;
		padding: 0;
		border: 2px solid #c5ceda;
		border-radius: 50%;
		background: #ffffff;
		color: #ffffff;
		font-size: 12px;
		line-height: 1;
		cursor: pointer;
	}

	.chat-resource-select-dot.selected {
		border-color: #409eff;
		background: #409eff;
	}

	.chat-resource-thumb,
	.chat-resource-icon {
		flex: 0 0 auto;
		width: 44px;
		height: 44px;
		margin-right: 12px;
		border-radius: 6px;
	}

	.chat-resource-thumb {
		object-fit: cover;
		background: #eef0f3;
	}

	.chat-resource-icon {
		display: inline-flex;
		align-items: center;
		justify-content: center;
		background: #edf2f7;
		color: #64748b;
		font-size: 22px;
	}

	.chat-resource-icon-file {
		background: #eef6ff;
		color: #2b6fdb;
	}

	.chat-resource-icon-media {
		background: #f0fdf4;
		color: #1f9d55;
	}

	.chat-resource-icon-link {
		background: #fff7ed;
		color: #f0642f;
	}

	.chat-resource-icon-location {
		background: #fff1f2;
		color: #e11d48;
	}

	.chat-resource-info {
		flex: 1;
		min-width: 0;
		text-align: left;
	}

	.chat-resource-title {
		font-size: 14px;
		line-height: 20px;
		font-weight: 600;
		color: #1f2937;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	.chat-resource-summary {
		margin-top: 3px;
		font-size: 12px;
		line-height: 18px;
		color: #7b8190;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	.chat-resource-meta {
		display: flex;
		align-items: center;
		justify-content: space-between;
		gap: 10px;
		margin-top: 5px;
		font-size: 12px;
		line-height: 16px;
		color: #a0a7b2;
	}

	.chat-resource-meta span {
		min-width: 0;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	.chat-resource-action-menu {
		position: fixed;
		z-index: 3000;
		min-width: 104px;
		padding: 6px 0;
		background: #ffffff;
		border: 1px solid #ebeef5;
		border-radius: 4px;
		box-shadow: 0 2px 12px rgba(0, 0, 0, 0.14);
	}

	.chat-resource-action-item {
		display: block;
		width: 100%;
		height: 34px;
		padding: 0 16px;
		border: none;
		background: transparent;
		color: #303133;
		font-size: 13px;
		line-height: 34px;
		text-align: left;
		white-space: nowrap;
		cursor: pointer;
	}

	.chat-resource-action-item:hover {
		background: #f5f7fa;
		color: #409eff;
	}
}
</style>
